"use strict";

var _document$querySelect;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var BN = BN || {},
  BNApp,
  vueApp;
var mediaQueryMobile = window.matchMedia("screen and (max-width: 767px)");
var mediaQueryTablet = window.matchMedia("screen and (min-width: 768px) and (max-width: 1199px)");
BN.screenMode = mediaQueryMobile.matches ? 'mobile' : mediaQueryTablet.matches ? 'tablet' : 'desktop';
BN.apiDomain = window.origin;
BN.wHeight = 0;
BN.wWidth = 0;
BN.headerElm;
BN.bodyWidth = 0;
BN.domContentLoadedFncList = BN.domContentLoadedFncList || [];
BN.vueMountedFncList = [];
BN.windowResizeFncList = {};
BN.scrollEventFncList = {};
BN.scrollUpEventFncList = {};
BN.scrollDownEventFncList = {};
BN.onDropdownCloseFncList = {};
BN.onClickDocumentFnList = {};
BN.isScreenReaderMode = false;
BN.version = document.firstElementChild.dataset.version;
BN.delayInitializeFnc = BN.delayInitializeFnc || {
  isInitialized: false,
  list: [],
  reinitializedList: []
};
BN.listDialogCursor = [];
BN.vueComponentsToLoad = []; //Array of {name, url} objects

//To remove a fnc from list: delete BN.scrollEventFncList.someEventName;
//after remove "someEventName" from List, "someEventName" is no longer executed

BN.checkIsMobile = function () {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' || /Macintosh/i.test(navigator.userAgent)) && navigator.maxTouchPoints > 0;
};
BN.checkIsIOS = function () {
  return /iPad|iPhone|iPod|Safari/.test(navigator.userAgent) && !window.MSStream;
};
BN.defaultConfig = {
  currencyCode: (_document$querySelect = document.querySelector("html")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.getAttribute("currency-code")
};
BN.breakpoints = {
  desktop: 992,
  laptop: 1200
};
BN.debounce = function (func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};
BN.omit = function (obj) {
  var result = _objectSpread({}, obj);
  for (var _len = arguments.length, props = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    props[_key - 1] = arguments[_key];
  }
  props.forEach(function (prop) {
    delete result[prop];
  });
  return result;
};
BN.throttleTimerList = [];
BN.throttle = function (func) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 150;
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    BN.throttleTimerList.forEach(function (timerItem) {
      clearTimeout(timerItem);
    });
    var context = this; // store the context of the object that owns this function
    var timer = setTimeout(function () {
      func.apply(context, args); // execute the function with the context of the object that owns it
    }, delay);
    BN.throttleTimerList.push(timer);
  };
};
BN.throttleTargetList = new Map();
BN.throttleTarget = function (func) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 150;
  var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '*';
  return function () {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    clearTimeout(BN.throttleTargetList.get(target));
    var context = this; // store the context of the object that owns this function
    var timer = setTimeout(function () {
      func.apply(context, args); // execute the function with the context of the object that owns it
    }, delay);
    BN.throttleTargetList.set(target, timer);
  };
};
BN.sleep = function (ms) {
  var start = new Date().getTime();
  while (new Date().getTime() < start + ms);
};
BN.copy = function (input) {
  if (_typeof(input) !== 'object') return input;
  return JSON.parse(JSON.stringify(input));
};
BN.slugify = function (text) {
  return text.toString().normalize('NFKD').toLowerCase().trim().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/-\+/g, '-');
};
BN.mergeDeep = function (target, source) {
  function isObject(item) {
    return item && _typeof(item) === 'object' && !Array.isArray(item);
  }
  var output = Object.assign({}, target);
  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(function (key) {
      if (isObject(source[key])) {
        if (!(key in target)) Object.assign(output, _defineProperty({}, key, source[key]));else output[key] = BN.mergeDeep(target[key], source[key]);
      } else {
        Object.assign(output, _defineProperty({}, key, source[key]));
      }
    });
  }
  return output;
};
BN.timer = function (callback, delay) {
  var timerId,
    timeStart,
    remaining = delay;
  var pause = function pause() {
    window.clearTimeout(timerId);
    timerId = null;
    remaining -= Date.now() - timeStart;
  };
  var resume = function resume() {
    if (timerId) {
      return;
    }
    timeStart = Date.now();
    timerId = window.setTimeout(function () {
      remaining = 0;
      callback();
    }, remaining);
  };
  var stop = function stop() {
    window.clearTimeout(timerId);
    remaining = 0;
    timerId = null;
  };
  var restart = function restart() {
    stop();
    remaining = delay;
    resume();
  };
  var start = function start() {
    remaining = delay;
    resume();
  };
  var running = function running() {
    return !!remaining;
  };
  return {
    start: start,
    pause: pause,
    resume: resume,
    stop: stop,
    restart: restart,
    running: running
  };
};
BN.imageProductResized = function (imageUrl, width, quality) {
  var imageFormatSupportOldBrowser = function imageFormatSupportOldBrowser() {
    try {
      var _window$isDeviceSuppo;
      return !window.isDeviceSupport || ((_window$isDeviceSuppo = window.isDeviceSupport) === null || _window$isDeviceSuppo === void 0 ? void 0 : _window$isDeviceSuppo.toLowerCase()) === 'true' ? 'webp' : 'jpeg';
    } catch (error) {
      console.log(error);
      return 'webp';
    }
  };
  if (!window.isCloudflareImageResizerAvailable || window.isCloudflareImageResizerAvailable.toLowerCase() === 'false') {
    return "".concat(imageUrl, "?width=").concat(width, "&format=").concat(imageFormatSupportOldBrowser(), "&quality=").concat(quality);
  }
  return "/cdn-cgi/image/width=".concat(width, ",format=").concat(imageFormatSupportOldBrowser(), ",quality=").concat(quality).concat(imageUrl);
};

//===========Vue Define

BN.vueData = {
  data: {},
  mixins: [],
  components: {},
  computed: {},
  methods: {},
  computedList: {},
  methodsList: {},
  createdFnList: [],
  mountedFnList: []
};
BN.SetVueData = function (componentName, obj) {
  BN.vueData.data[componentName] = obj;
};

// BN.ExtendVueConfig = function(componentName, obj){
//     if(obj.data) {
//         let tmpData = BN.vueData.data[componentName];
//         let tmpDataNew = BN.mergeDeep(tmpData, obj.data);
//         BN.vueData.data[componentName] = tmpDataNew;
//     }

//     if(obj.computed) {
//         if(BN.vueData.computedList[componentName + 'Fn'])
//             BN.vueData.computedList[componentName + 'Fn'] = {...BN.vueData.computedList[componentName + 'Fn'], ...obj.computed}
//         else
//             BN.vueData.computedList[componentName + 'Fn'] = obj.computed

//         BN.vueData.computed[componentName + 'Fn'] = function() {
//             return BN.vueData.computedList[componentName + 'Fn']
//         }
//     }

//     if(obj.methods) {
//         if(BN.vueData.methodsList[componentName + 'Md'])
//             BN.vueData.methodsList[componentName + 'Md'] = {...BN.vueData.methodsList[componentName + 'Md'], ...obj.methods}
//         else
//             BN.vueData.methodsList[componentName + 'Md'] = obj.methods

//         BN.vueData.methods[componentName + 'Md'] = function() {
//             return BN.vueData.methodsList[componentName + 'Md']
//         }
//     }

//     if(obj.created)
//         BN.vueData.createdFnList.push(obj.created);

//     if(obj.mounted)
//         BN.vueData.mountedFnList.push(obj.mounted);
// }

//This function should be used before creation of vue app
BN.LoadVueComponentAtStartup = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(componentName, url, isFromSv) {
    var component, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.p = 0;
          if (!url) {
            console.log("Could not load Vue component ".concat(componentName, ", url is null or empty"));
          }

          //let url = isFromSv ? BN.apiDomain + path : `/dist/Brownells/js/components/${path}.vue`;
          url += (url.indexOf("?") >= 0 ? "&v=" : "?v=") + BN.version;
          _context.n = 1;
          return httpVueLoader(url, componentName)();
        case 1:
          component = _context.v;
          // component.render = BN.manuallyCompile?.compile(component.template) || component.render;

          BN.vueData.components[componentName] = component;
          if (!(component !== null && component !== void 0 && component.data) || component !== null && component !== void 0 && component.data && !component.data())
            //No idea what on earth is this, copied from methods below
            {
              component.data = function () {
                return BN.vueData.data;
              };
            }
          _context.n = 3;
          break;
        case 2:
          _context.p = 2;
          _t = _context.v;
          console.error(_t);
        case 3:
          return _context.a(2);
      }
    }, _callee, null, [[0, 2]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
BN.LoadComponent = function (path, isFromSv, componentName) {
  var url = isFromSv ? BN.apiDomain + path : "/dist/Brownells/js/components/".concat(path, ".vue");
  url += (url.indexOf("?") >= 0 ? "&v=" : "?v=") + BN.version;
  var resultFunction = httpVueLoader(url, componentName);
  var result = resultFunction();
  return result;
};
BN.SetVueComponent = function (componentName, path) {
  BN.vueData.components[componentName] = BN.LoadComponent(path);
};
BN.SetVueComponentAtRunTime = function (componentName, path, isFromSv, callback, data, cacheTemplate) {
  if (typeof cacheTemplate == "undefined") cacheTemplate = true;
  var updateViewApp = function updateViewApp() {
    BNApp.$forceUpdate();
    BNApp.$nextTick(function () {
      if (callback) callback();
    });
  };
  var afterLoadComponent = function afterLoadComponent(component) {
    if (!(component !== null && component !== void 0 && component.data) || component !== null && component !== void 0 && component.data && !component.data()) {
      component.data = function () {
        return BN.vueData.data;
      };
    }
    vueApp.component(componentName, component);
    BN.vueData.components[componentName] = component;
    updateViewApp();
  };
  if (cacheTemplate && _typeof(BN.vueData.components[componentName]) == "object") {
    if (data) BN.vueData.components[componentName].props.data = data;
    updateViewApp();
  } else {
    BN.vueData.components[componentName] = null;
    if (typeof path === 'string') {
      BN.LoadComponent(path, isFromSv, componentName).then(function (component) {
        var _BN$manuallyCompile;
        component.render = ((_BN$manuallyCompile = BN.manuallyCompile) === null || _BN$manuallyCompile === void 0 ? void 0 : _BN$manuallyCompile.compile(component.template)) || component.render;
        if (data) component.props.data = data;
        afterLoadComponent(component);
      })["catch"](function (e) {
        return console.error(e);
      });
    } else if (_typeof(path) === 'object') {
      afterLoadComponent(path);
    }
  }
};
BN.KeyName = {
  "enter": "Enter"
};
BN.Key = {
  ARROW_UP: 38,
  ARROW_DOWN: 40,
  ENTER: 13,
  ESCAPE: 27,
  SPACE: 32,
  END: 35,
  HOME: 36,
  PAGE_UP: 33,
  PAGE_DOWN: 34
};
BN.StorageKey = {
  "username": "USER_NAME",
  "prevUrl": "PREV_URL",
  "btnPopupElem": "BUTTON_POPUP_ELEM",
  "hasLoginPopup": "HAS_LOGIN_POPUP",
  "hasLoginToCheckoutPopup": "HAS_LOGIN_CHECKOUT_POPUP",
  "hasLoginFavoritePopup": "HAS_LOGIN_FAVORITE_POPUP",
  "loginFromFavorite": "LOGIN_FROM_FAVORITE",
  "redirectToPlpFromSearchHeader": "REDIRECT_TO_PLP_FROM_SEARCH_HEADER"
};
BN.Regex = {
  'allCaseCharacter': new RegExp(/([a-z].*[A-Z])|([A-Z].*[a-z])/),
  'specialCharacter': new RegExp(/([~!%&@#$^*?\-_+=;:'"<,.>\(\)\{\}\[\]\|\\\/]{1,})/),
  'number': new RegExp(/([0-9])/),
  'allRule': new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~!%&@#$^*?\-_+=;:'"<,.>\(\)\{\}\[\]\|\\\/])[A-Za-z\d~!%&@#$^*?\-_+=;:'"<,.>\(\)\{\}\[\]\|\\\/]{8,}$/),
  'email': new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i),
  'nonASCII': new RegExp(/[^\x00-\x7F]+/)
};
BN.MaxLengthInput = {
  'email': 60,
  'phone': 16,
  'fflNumber': 36,
  'billingFirstName': 30,
  'billingLastName': 30,
  'billingShopName': 36,
  'billingAddressLine1': 36,
  'billingAddressLine2': 36,
  'billingCity': 20,
  'billingCountry': 3,
  'billingState': 2,
  'billingZipCode': 10,
  'deliveryFirstName': 30,
  'deliveryLastName': 30,
  'deliveryShopName': 36,
  'gcMessage': 40
};
BN.RegisterAccountCode = {
  'invalidUsername': 1,
  'invalidEmailBillingAddress': 2,
  'invalidPassword': 3
};
BN.AttributeStatusToClassName = {
  1: "attribute-in-stock",
  2: "attribute-back-order",
  3: "attribute-pre-order",
  4: "attribute-notify-me",
  5: "attribute-no-longer-available"
};
BN.onChangePhoneCode = function (evt, refInputName, listPhoneCodes) {
  var _currentOption$;
  var currentOption = listPhoneCodes.filter(function (item) {
    return item.code == evt.target.value;
  });
  if ((_currentOption$ = currentOption[0]) !== null && _currentOption$ !== void 0 && _currentOption$.dialCode) {
    BNApp.$refs[refInputName].setAttribute("maxlength", BN.MaxLengthInput.phone - currentOption[0].dialCode.length);
  }
};
BN.formatPrice = function (price) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '${{amount}}';
  var numberDigitRound = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  if (!price) price = 0;
  var floatPrice = parseFloat(price);
  if (isNaN(floatPrice)) return price;
  var strPrice;
  if (numberDigitRound == -1) {
    strPrice = Math.abs(floatPrice).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    strPrice = Math.abs(floatPrice).toFixed(numberDigitRound).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return (floatPrice < 0 ? '-' : '') + format.replace(/{{amount}}/, strPrice);
};
BN.formatString = function (stringTemplate) {
  for (var _len4 = arguments.length, params = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    params[_key4 - 1] = arguments[_key4];
  }
  if (params && params.length) {
    for (var i = 0; i < params.length; i++) {
      stringTemplate = stringTemplate.replace("{".concat(i, "}"), params[i]);
    }
  }
  return stringTemplate;
};
BN.formatInfoFFLDealer = function (model) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "address";
  var strConverted = "";
  if (!model) {
    return strConverted;
  }
  if (type === "address") {
    if (model.street) {
      strConverted += model.street;
    }
    if (model.city) {
      strConverted += ' ' + model.city;
    }
    if (model.stateCode || model.zipCode) {
      strConverted += ', ';
      if (model.stateCode) {
        strConverted += model.stateCode;
      }
      if (model.zipCode) {
        strConverted += ', ' + model.zipCode;
      }
    }
  } else {
    var phone = model.phone ? model.phone : model.phoneNumber;
    if (phone) {
      if (model.countryCodeForPhone) {
        strConverted += '(' + model.countryCodeForPhone + ') ' + phone;
      } else {
        strConverted += phone;
      }
    }
  }
  return strConverted;
};
BN.equalsObject = function (a, b) {
  if (a === b) return true;
  if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
  if (!a || !b || _typeof(a) !== 'object' && _typeof(b) !== 'object') return a === b;
  if (a.prototype !== b.prototype) return false;
  var keys = Object.keys(a);
  if (keys.length !== Object.keys(b).length) return false;
  return keys.every(function (k) {
    return BN.equalsObject(a[k], b[k]);
  });
};
BN.selectElementContents = function (el) {
  var range = document.createRange();
  range.selectNodeContents(el);
  var sel = window.getSelection();
  sel.removeAllRanges();
  sel.addRange(range);
};
BN.lazyLoadFiles = function (files, callback, isSelfHosting) {
  var node;
  var loadFile = function loadFile(url, type) {
    return new Promise(function (resolve) {
      node = document.createElement(type === 'css' ? 'link' : 'script');
      if (type === 'css') {
        node.type = 'text/css';
        node.rel = 'stylesheet';
        node.href = isSelfHosting ? "/dist/Brownells/css/" + url + "?v=" + BN.version : url;
      } else if (type === 'js') {
        node.type = 'text/javascript';
        node.src = isSelfHosting ? "/dist/Brownells/js/" + url + "?v=" + BN.version : url;
      }
      node.onload = function () {
        resolve({
          isError: false,
          url: url,
          type: type
        });
      };
      node.onerror = function () {
        resolve({
          isError: true,
          url: url,
          type: type
        });
      };
      window.document.head.append(node);
    });
  };
  var promies = [],
    type;
  for (type in files) {
    files[type].forEach(function (url) {
      promies.push(loadFile(url, type));
    });
  }
  Promise.all(promies).then(function (responses) {
    callback && callback(responses);
  });
};
BN.encodeHtml = function (e) {
  return e.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
};
BN.decodeHtml = function (input) {
  if (!input) return '';
  var e = document.createElement('textarea');
  e.innerHTML = input;
  var result = e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
  e.remove();
  return result;
};
BN.eventSelectVariantCallBacks = new Set();
BN.setEventSelectVariant = function () {
  var cbAfter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var isRefreshComponent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var componentName = 'choose-variants';
  var isInitVueComponent = BN.vueData.components.hasOwnProperty(componentName);
  cbAfter && BN.eventSelectVariantCallBacks.add(cbAfter);
  if (document.addedEventSelectVariant) {
    return;
  }
  document.addedEventSelectVariant = true;
  document.addEventListener('click', function (e) {
    var target = e.target,
      dialogCursor = target.closest('[dialog-variant-cursor]'),
      dataDialogAddCart = BNApp.dialogAddCart;
    if (dialogCursor) {
      var isOnlyNotifyMe = dialogCursor.hasAttribute('datalayer-notify-me-click');
      var datalayerPid = dialogCursor.dataset.datalayerPid || dialogCursor.dataset.pid;
      dataDialogAddCart.volumeDiscount.data = [];
      dataDialogAddCart.datalayerPid = datalayerPid;
      if (isOnlyNotifyMe && datalayerPid) {
        var productList = dialogCursor.dataset.productList || "";
        BN.pushDataLayer(null, null, {
          'event': 'click_notify_me',
          'type': 'button',
          'interactionText': dialogCursor === null || dialogCursor === void 0 ? void 0 : dialogCursor.innerText,
          'location': 'Product Listing',
          'itemListName': productList,
          'pid': datalayerPid,
          'sku': dialogCursor.dataset.datalayerVid
        });
      }
    }
    if (dialogCursor && (dialogCursor.dataset.pid || dialogCursor.dataset.vid)) {
      var _target$closest, _productItemNode$data;
      var productItemNodes = Array.from((target === null || target === void 0 || (_target$closest = target.closest(".category-slider__items")) === null || _target$closest === void 0 ? void 0 : _target$closest.querySelectorAll(".category-slider__item")) || []),
        productItemNode = target.closest(".category-slider__item"),
        _isOnlyNotifyMe = dialogCursor.hasAttribute('dialog-notify-me');
      if (!isInitVueComponent) {
        BN.SetVueComponentAtRunTime(componentName, "variant/choose", false, function () {
          var _BNApp$dialogAddCart;
          isRefreshComponent && ((_BNApp$dialogAddCart = BNApp.dialogAddCart) === null || _BNApp$dialogAddCart === void 0 ? void 0 : _BNApp$dialogAddCart.refresh) !== undefined && (BNApp.dialogAddCart.refresh = new Date().getTime());
        });
        isInitVueComponent = true;
      }
      dataDialogAddCart.onlyNotifyMe = _isOnlyNotifyMe;
      dataDialogAddCart.allVariantOutOfStock = dialogCursor.hasAttribute('all-variant-out-stock');
      if (dialogCursor.dataset.vid !== undefined) {
        dataDialogAddCart.variantCode = dialogCursor.dataset.vid;
      }
      if (dialogCursor.dataset.pid !== undefined) {
        dataDialogAddCart.productCode = dialogCursor.dataset.pid;
      }
      dataDialogAddCart.isReload = !dataDialogAddCart.isReload;
      dataDialogAddCart.variant = {};

      // set datalayer event add to cart
      if (dialogCursor.dataset.productPosition) {
        dataDialogAddCart.productPosition = dialogCursor.dataset.productPosition;
      } else if (productItemNodes.length && productItemNode) {
        dataDialogAddCart.productPosition = productItemNodes.indexOf(productItemNode) + 1;
      }
      if (dialogCursor.dataset.productList) {
        dataDialogAddCart.productList = dialogCursor.dataset.productList;
      } else if (productItemNode !== null && productItemNode !== void 0 && (_productItemNode$data = productItemNode.dataset) !== null && _productItemNode$data !== void 0 && _productItemNode$data.productList) {
        dataDialogAddCart.productList = productItemNode.dataset.productList;
      }
      BNApp.$data.selections = [];
      BN.eventSelectVariantCallBacks.forEach(function (func) {
        if (typeof func === 'function') {
          func(dialogCursor);
        }
      });
    }
    if (dialogCursor && dialogCursor.dataset.productUrl !== undefined) {
      dataDialogAddCart.productUrl = dialogCursor.dataset.productUrl;
    }
  });
};
BN.setEventSelectVariantForCartRecs = function () {
  var cbAfter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var isRefreshComponent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var componentName = 'choose-variants';
  var isInitVueComponent = BN.vueData.components.hasOwnProperty(componentName);
  document.addedEventSelectVariantForCartRecs = true;
  document.querySelectorAll(".mini-cart [dialog-variant-cursor]").forEach(function (elm) {
    elm.addEventListener("click", function (e) {
      var target = e.target;
      var dataDialogAddCart = BNApp.dialogAddCart;
      if (target && (target.dataset.pid || target.dataset.vid)) {
        if (!isInitVueComponent) {
          BN.SetVueComponentAtRunTime(componentName, "variant/choose", false, function () {
            var _BNApp$dialogAddCart2;
            isRefreshComponent && ((_BNApp$dialogAddCart2 = BNApp.dialogAddCart) === null || _BNApp$dialogAddCart2 === void 0 ? void 0 : _BNApp$dialogAddCart2.refresh) !== undefined && (BNApp.dialogAddCart.refresh = new Date().getTime());
          });
          isInitVueComponent = true;
        }
        dataDialogAddCart.onlyNotifyMe = target.hasAttribute('dialog-notify-me');
        dataDialogAddCart.allVariantOutOfStock = target.hasAttribute('all-variant-out-stock');
        if (target.dataset.vid !== undefined) {
          dataDialogAddCart.variantCode = target.dataset.vid;
        } else if (target.dataset.pid !== undefined) {
          dataDialogAddCart.productCode = target.dataset.pid;
        }
        dataDialogAddCart.isReload = !dataDialogAddCart.isReload;
        dataDialogAddCart.variant = {};
        dataDialogAddCart.productPosition = target.dataset.productPosition;
        dataDialogAddCart.productList = target.dataset.productList;
        BNApp.$data.selections = [];
        typeof cbAfter === 'function' && cbAfter(target);
      }
      if (target && target.dataset.productUrl !== undefined) {
        dataDialogAddCart.productUrl = target.dataset.productUrl;
      }
    });
  });
  var miniCart = document.querySelector(".mini-cart .mini-cart__wrap");
  if (miniCart && !miniCart.addedEventSelectVariantForCartRecs) {
    miniCart.addedEventSelectVariantForCartRecs = true;
    miniCart.addEventListener("click", function (e) {
      var _e$target;
      var dialogCursor = (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.closest('[dialog-variant-cursor]');
      if (dialogCursor) {
        var productList = dialogCursor.dataset.productList,
          datalayerPid = dialogCursor.dataset.datalayerPid || dialogCursor.dataset.pid;
        if (dialogCursor.hasAttribute('datalayer-notify-me-click') && datalayerPid && productList) {
          BN.pushDataLayer(null, null, {
            'event': 'click_notify_me',
            'type': 'button',
            'interactionText': dialogCursor.innerText,
            'location': 'Product Listing',
            'itemListName': productList,
            'pid': datalayerPid,
            'sku': dialogCursor.dataset.datalayerVid
          });
        }
      }
    });
  }
};
BN.cacheListOfProduct = function (data_object, event) {
  var _data_object$ecommerc;
  if ((data_object === null || data_object === void 0 ? void 0 : data_object.event) === 'select_item' && data_object !== null && data_object !== void 0 && (_data_object$ecommerc = data_object.ecommerce) !== null && _data_object$ecommerc !== void 0 && (_data_object$ecommerc = _data_object$ecommerc.click) !== null && _data_object$ecommerc !== void 0 && _data_object$ecommerc.products[0]) {
    var _data_object$ecommerc2, _data_object$ecommerc3, _data_object$ecommerc4;
    var currentDate = new Date();
    var cacheListOfProduct = {
      id: data_object === null || data_object === void 0 || (_data_object$ecommerc2 = data_object.ecommerce) === null || _data_object$ecommerc2 === void 0 || (_data_object$ecommerc2 = _data_object$ecommerc2.click) === null || _data_object$ecommerc2 === void 0 || (_data_object$ecommerc2 = _data_object$ecommerc2.products[0]) === null || _data_object$ecommerc2 === void 0 ? void 0 : _data_object$ecommerc2.id,
      expiresAt: currentDate.setDate(currentDate.getDate() + 1),
      list: data_object === null || data_object === void 0 || (_data_object$ecommerc3 = data_object.ecommerce) === null || _data_object$ecommerc3 === void 0 || (_data_object$ecommerc3 = _data_object$ecommerc3.click) === null || _data_object$ecommerc3 === void 0 || (_data_object$ecommerc3 = _data_object$ecommerc3.actionField) === null || _data_object$ecommerc3 === void 0 ? void 0 : _data_object$ecommerc3.list,
      position: data_object === null || data_object === void 0 || (_data_object$ecommerc4 = data_object.ecommerce) === null || _data_object$ecommerc4 === void 0 || (_data_object$ecommerc4 = _data_object$ecommerc4.click) === null || _data_object$ecommerc4 === void 0 || (_data_object$ecommerc4 = _data_object$ecommerc4.actionField) === null || _data_object$ecommerc4 === void 0 ? void 0 : _data_object$ecommerc4.position
    };
    if (event.ctrlKey) {
      localStorage.setItem("cacheListOfProduct", JSON.stringify(cacheListOfProduct));
    } else {
      sessionStorage.setItem("cacheListOfProduct", JSON.stringify(cacheListOfProduct));
    }
  }
};
BN.pushDataLayer = function (element, event, data_object) {
  if (element && event) {
    element.addEventListener(event, function (e) {
      //Google still can track events even Network speed is 1Kbps
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(data_object);
      BN.cacheListOfProduct(data_object, e);
    });
  } else if (!element && !event) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data_object);
  }
};
BN.waitForElmRendering = function (selector, timeout) {
  var it;
  return new Promise(function (resolve) {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }
    if (!timeout) {
      timeout = 15000;
    }
    it = setTimeout(function () {
      if (observer) {
        observer.disconnect();
        resolve();
      }
    }, timeout);
    var observer = new MutationObserver(function () {
      if (document.querySelector(selector)) {
        observer.disconnect();
        it && clearTimeout(it);
        resolve(document.querySelector(selector));
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
};
BN.collectVolumeDiscountInfo = function (settings, data) {
  var amountLabel = settings.popupAmountColumnName,
    priceLabel = settings.popupPriceColumnName,
    quantityLabel = settings.popupQuantityColumnName,
    volumeDiscountTitle = settings.popupTitle,
    iconOnPdpUrl = settings.iconOnPdpUrl,
    textOnPdp = settings.textOnPdp;
  BNApp.dialogAddCart.volumeDiscount.iconOnPdpUrl = iconOnPdpUrl;
  BNApp.dialogAddCart.volumeDiscount.textOnPdp = textOnPdp;
  BNApp.dialogAddCart.volumeDiscount.data = data;
  BNApp.dialogAddCart.volumeDiscount.title = volumeDiscountTitle || "Volume Discount";
  BNApp.dialogAddCart.volumeDiscount.columns = [quantityLabel || "Quantity", priceLabel || "Price Per Unit", amountLabel || "Total Amount"];
};
function LogObjectChange(objectPath) {
  var evalString = "".concat(objectPath, " = new Proxy(").concat(objectPath, ", { set(target, key, value) { console.trace(`").concat(objectPath, " changed: ${key} - ${value}`); target[key] = value; return true; } })");
  eval(evalString);
  return evalString;
}
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var dispathEvent = {
  open: function open(target) {
    var customEvent = new CustomEvent('dialogOpen', {
      detail: {
        target: target
      }
    });
    document.dispatchEvent(customEvent);
  },
  close: function close(target) {
    var customEvent = new CustomEvent('dialogClose', {
      detail: {
        target: target
      }
    });
    document.dispatchEvent(customEvent);
  }
};
var DropdownService = /*#__PURE__*/function () {
  function DropdownService() {
    _classCallCheck(this, DropdownService);
  }
  return _createClass(DropdownService, [{
    key: "init",
    value: function init(container) {
      var dropdownElms = (container || document).querySelectorAll("[show-dropdown]"),
        self = this;
      dropdownElms.forEach(function (dropdownElm) {
        dropdownElm.querySelectorAll("[dropdown-cursor]").forEach(function (cursor) {
          if (cursor.closest("[show-dropdown]") == dropdownElm) {
            if (!cursor.initializedDropdown) {
              cursor.initializedDropdown = true;
              cursor.addEventListener("click", function (e) {
                self.show(e.target.closest("[dropdown-cursor]"), null, true);
              });
            }
          }
        });
      });
    }
  }, {
    key: "getListFocusableElms",
    value: function getListFocusableElms(element) {
      // let activeElement = document.activeElement;
      // if(element.contains(activeElement)) return null;
      return element.querySelectorAll('a[href]:not([hide-on-desktop]), button:not([disabled]):not([hide-on-desktop]), input:not([disabled]):not([type="hidden"]), textarea, select:not([disabled]), details, [tabindex]:not([tabindex="-1"])');
    }

    // close(e) {
    //     let activePanelElm = e.target.closest("[dropdown-panel].show");
    //     if(!activePanelElm)
    //         return;

    //         BN.dropdownService.close()
    //     activePanelElm.classList.remove("show");
    //     BN.lockScrollIos.offAll();
    //     dispathEvent.close(activePanelElm);
    // }
  }, {
    key: "close",
    value: function close(e, panelElm) {
      var _cursorElm$classList;
      // if(panelElm && panelElm.dataset.onclose) {
      //     panelElm.dataset.onclose(e);
      // }

      panelElm = panelElm ? panelElm : e.target.closest("[dropdown-panel].show");
      if (!panelElm) return;else {
        var loginRecaptcharEl = panelElm.querySelector(".login_display_recaptcha");
        if (loginRecaptcharEl) {
          var recaptchaEl = document.querySelector(".grecaptcha-badge");
          if (typeof updateReCaptchaInterval != 'undefined') {
            clearInterval(updateReCaptchaInterval);
          }
          loginRecaptcharEl.parentNode.removeChild(loginRecaptcharEl);
          if (recaptchaEl) {
            recaptchaEl.classList.remove('active');
          }
        }
      }
      Object.keys(BN.onDropdownCloseFncList).forEach(function (k) {
        BN.onDropdownCloseFncList[k](e);
      });
      var cursorElm = BN.listDialogCursor[BN.listDialogCursor.length - 1];
      BN.listDialogCursor = BN.listDialogCursor.slice(0, -1);
      panelElm.classList.remove("show");
      BN.lockScrollIos.offAll();
      cursorElm === null || cursorElm === void 0 || (_cursorElm$classList = cursorElm.classList) === null || _cursorElm$classList === void 0 || _cursorElm$classList.remove('active');
      document.body.classList.remove("showing-megamenu");
      document.body.classList.remove("showing-popover");
      if (panelElm.classList.contains("mini-cart") && BNApp.cart) {
        BNApp.cart.showcart = false;
      }
      this.hideDialogComplete();
      dispathEvent.close(panelElm);
      this.resetStyleElm(panelElm);
      if (BN.isScreenReaderMode && cursorElm) {
        cursorElm.focus();
        var targetPanelCursorContainer = cursorElm.closest("[show-dropdown]");
        if (targetPanelCursorContainer) {
          var _BNApp$cart;
          if ((_BNApp$cart = BNApp.cart) !== null && _BNApp$cart !== void 0 && _BNApp$cart.showcart) {
            BN.CartService.autoFocusAtFirstElm(true);
          } else BN.dropdownService.loopFocus(document.querySelector(targetPanelCursorContainer.dataset.target), null, true);
        }
      }
    }
  }, {
    key: "hideDialogComplete",
    value: function hideDialogComplete() {
      setTimeout(function () {
        if (!BN.listDialogCursor.length) {
          document.body.classList.remove("showing-dialog");
        }
      }, 250);
    }
  }, {
    key: "closeAll",
    value: function closeAll() {
      window.document.body.click();
    }
  }, {
    key: "show",
    value: function show(currentCursor, targetCursor, isToggle) {
      var _parentElm$dataset;
      //targetCursor = event or element
      if (typeof currentCursor == "string") currentCursor = document.querySelector(currentCursor);
      var self = this,
        parentElm = currentCursor.closest("[show-dropdown]"),
        targetPanel = document.querySelector(parentElm.dataset.target);
      if (targetPanel.classList.contains('dialog-login')) {
        var templateRecaptcha = document.querySelector(".template-recaptcha");
        var cloneEl = templateRecaptcha.content.cloneNode(true);
        targetPanel.querySelector('.login__form').appendChild(cloneEl);
        var errorMessageEl = targetPanel.querySelector(".login__form__general-msg");
        if (errorMessageEl.dataset.errorEdgeMember === "true" && BNApp.cart && !BNApp.cart.isEdgeMembershipInCart) {
          errorMessageEl.dataset.errorEdgeMember = "false";
          errorMessageEl.innerText = "";
        }
      }
      if (targetCursor) {
        currentCursor = targetCursor.target || targetCursor;
        currentCursor.setAttribute("dropdown-cursor", "");
        BN.listDialogCursor.push(currentCursor);
      } else BN.listDialogCursor.push(currentCursor);
      if (targetPanel) {
        if (!currentCursor.classList.contains("active")) {
          dispathEvent.open(targetPanel);
          parentElm.querySelectorAll("[dropdown-cursor].active").forEach(function (activeCursorElm) {
            activeCursorElm.classList.remove("active");
          });
          if (targetPanel.dataset.lockScroll !== undefined) {
            targetPanel.querySelectorAll('[data-scroll]').forEach(function (elm) {
              BN.lockScrollIos.on(elm);
            });
          }
          currentCursor.classList.add("active");
          parentElm.classList.add("opening");
          targetPanel.classList.add("show");
          // targetPanel.style.opacity = 0;
          var pos = parentElm.getBoundingClientRect();
          pos.y = pos.y + pos.height;
          pos.x = pos.x - targetPanel.offsetWidth.width / 2;
          // parentElm.offsetLeft + (parentElm.offsetWidth / 2) - (targetPanel.offsetWidth / 2)
          switch (parentElm.dataset.name) {
            case "nav":
              targetPanel.classList.remove("show-all");
              if (currentCursor.dataset.target === "all") {
                targetPanel.classList.add("show-all");
                pos = {
                  x: 0,
                  y: 0
                };
              }
              document.body.classList.add("showing-megamenu");
              break;
            case "dialog":
              pos = {
                x: 0,
                y: 0
              };
              setTimeout(function () {
                self.loopFocus(targetPanel);
              }, 500);
              document.body.classList.add("showing-dialog");
              break;
            case "mini-cart":
              pos = {
                x: 0,
                y: 0
              };
              document.body.classList.add("showing-dialog");
              break;
            case 'popover':
              document.body.classList.add("showing-popover");
              if (BN.screenMode !== 'desktop') {
                pos.y = 0;
              } else if (((_parentElm$dataset = parentElm.dataset) === null || _parentElm$dataset === void 0 ? void 0 : _parentElm$dataset.placement) === 'right') {
                var rectCursor = currentCursor.getBoundingClientRect();
                pos._x = BN.wWidth - (rectCursor.x + rectCursor.width);
              }
              break;
          }
          if (pos.x < 0) pos.x = 0;
          if (pos.y < 0) pos.y = 0;
          if (!parentElm.dataset.ignoreDetectPositionAutomatically) {
            targetPanel.style.left = "".concat(pos.x, "px");
            targetPanel.style.right = "".concat(pos._x, "px");
            targetPanel.style.top = "".concat(pos.y, "px");
            // targetPanel.style.opacity = 1;
            targetPanel.style.height = "calc(100% - ".concat(pos.y, "px)");
          }
          if (parentElm.dataset.height === "full") {
            targetPanel.style.height = "calc(100vh + ".concat(pos.y, "px)");
          }
        } else if (isToggle) {
          targetPanel.classList.remove("show");
          currentCursor.classList.remove("active");
          parentElm.classList.remove("opening");
          document.body.classList.remove("showing-megamenu");
          document.body.classList.remove("showing-popover");
          this.hideDialogComplete();
          this.resetStyleElm(targetPanel);
          BN.lockScrollIos.offAll();
          dispathEvent.close(targetPanel);
        }
      }
    }
  }, {
    key: "firstFocusableElmKeyHandler",
    value: function firstFocusableElmKeyHandler(e) {
      if (e.key == "Tab" && !e.shiftKey) {
        e.preventDefault();
        BN.dropdownService.firstFocusableElm.focus();
      }
    }
  }, {
    key: "lastFocusableElmKeyHandler",
    value: function lastFocusableElmKeyHandler(e) {
      if (e.key == "Tab" && e.shiftKey) {
        e.preventDefault();
        BN.dropdownService.lastFocusableElm.focus();
      }
    }
  }, {
    key: "loopFocus",
    value: function loopFocus(targetPanel, listFocusableElms, onlyLoopFocus) {
      var tmpListFocusableElms = listFocusableElms ? listFocusableElms : this.getListFocusableElms(targetPanel),
        tmpListFocusableElmsLength = tmpListFocusableElms.length,
        vm = this;
      if (tmpListFocusableElmsLength) {
        var _BN$dropdownService$l, _BN$dropdownService$f;
        tmpListFocusableElms.forEach(function (item, indx) {
          var _tmpListFocusableElms, _tmpListFocusableElms2;
          (_tmpListFocusableElms = tmpListFocusableElms[indx]) === null || _tmpListFocusableElms === void 0 || _tmpListFocusableElms.removeEventListener("keydown", vm.firstFocusableElmKeyHandler);
          (_tmpListFocusableElms2 = tmpListFocusableElms[indx]) === null || _tmpListFocusableElms2 === void 0 || _tmpListFocusableElms2.removeEventListener("keydown", vm.lastFocusableElmKeyHandler);
        });
        BN.dropdownService.firstFocusableElm = tmpListFocusableElms[0], BN.dropdownService.lastFocusableElm = tmpListFocusableElmsLength > 1 ? tmpListFocusableElms[tmpListFocusableElmsLength - 1] : BN.dropdownService.firstFocusableElm;
        if (!onlyLoopFocus) BN.dropdownService.firstFocusableElm.focus();
        (_BN$dropdownService$l = BN.dropdownService.lastFocusableElm) === null || _BN$dropdownService$l === void 0 || _BN$dropdownService$l.addEventListener("keydown", vm.firstFocusableElmKeyHandler);
        (_BN$dropdownService$f = BN.dropdownService.firstFocusableElm) === null || _BN$dropdownService$f === void 0 || _BN$dropdownService$f.addEventListener("keydown", vm.lastFocusableElmKeyHandler);
        return {
          firstFocusableElm: BN.dropdownService.firstFocusableElm,
          lastFocusableElm: BN.dropdownService.lastFocusableElm
        };
      }
    }
  }, {
    key: "resetStyleElm",
    value: function resetStyleElm(elm) {
      if (elm) {
        elm.style.top = null;
        elm.style.left = null;
        elm.style.right = null;
        elm.style.height = null;
      }
    }
  }, {
    key: "closeRemainingDropdown",
    value: function closeRemainingDropdown(selectorClassOrId) {
      document.querySelectorAll("[dropdown-panel].show").forEach(function (panelElm) {
        if (!panelElm.closest(selectorClassOrId)) {
          panelElm.classList.remove("show");
          BN.dropdownService.resetStyleElm(panelElm);
          dispathEvent.close(panelElm);
          BN.lockScrollIos.offAll();
        }
      });
      document.querySelectorAll("[dropdown-cursor].active").forEach(function (item) {
        if (!item.closest(selectorClassOrId)) {
          item.classList.remove("active");
        }
      });
      document.querySelectorAll("[show-dropdown].opening").forEach(function (item) {
        if (!item.closest(selectorClassOrId)) {
          item.classList.remove("opening");
        }
      });
    }
  }]);
}();
BN.domContentLoadedFncList.push(function () {
  BN.dropdownService = new DropdownService();
  BN.dropdownService.init();
  window.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      var latestCursor,
        listDialogCursorLength = BN.listDialogCursor.length;
      if (listDialogCursorLength) latestCursor = BN.listDialogCursor[listDialogCursorLength - 1];
      var panelElms = document.querySelectorAll("[dropdown-panel].show"),
        panelElms_length = panelElms.length;
      if (panelElms_length) {
        BN.dropdownService.close(null, panelElms[panelElms_length - 1]);
        if (latestCursor && BN.isScreenReaderMode) {
          latestCursor.focus();
        }
      }
    }
  });
  var mouseUpData = null,
    mouseDownData = null;
  window.addEventListener("mouseup", function (e) {
    mouseUpData = e;
  });
  window.addEventListener("mousedown", function (e) {
    mouseDownData = e;
  });
  window.addEventListener("click", function (e) {
    var _mouseDownData, _mouseUpData;
    var target = e.target;
    if (BN.listDialogCursor.indexOf(target) == -1 && target.closest("[dropdown-cursor]") == null && (!target.closest('[dropdown-panel-container]') || target.closest('[dropdown-panel-container]') && target.hasAttribute("dropdown-panel")) && !target.closest('.toast') && !target.closest('.disable-click-outside') && !target.closest('#onetrust-consent-sdk') && !target.closest('.bn-select') && ((_mouseDownData = mouseDownData) === null || _mouseDownData === void 0 ? void 0 : _mouseDownData.target) == ((_mouseUpData = mouseUpData) === null || _mouseUpData === void 0 ? void 0 : _mouseUpData.target)) {
      if (target.hasAttribute("dropdown-panel")) {
        BN.dropdownService.close(e);
      } else if (document.contains(target)) {
        //prevent close mini-cart automatically by clicking on body
        //call BN.cartCtrl.close() instead
        if (document.body.classList.contains("mini-cart--opening")) return;
        BN.listDialogCursor = [];
        document.querySelectorAll("[dropdown-panel].show").forEach(function (panelElm) {
          if (document.contains(target)) {
            panelElm.classList.remove("show");
            // const onCloseCallbackFn = panelElm.dataset?.onclose;
            // if(onCloseCallbackFn)
            //     eval(onCloseCallbackFn);
            BN.dropdownService.resetStyleElm(panelElm);
            dispathEvent.close(panelElm);
            BN.lockScrollIos.offAll();
          }
        });
        document.querySelectorAll("[dropdown-cursor].active").forEach(function (item) {
          item.classList.remove("active");
        });
        document.querySelectorAll("[show-dropdown].opening").forEach(function (item) {
          item.classList.remove("opening");
        });
      }

      // document.querySelectorAll(".bn-select");
      document.body.classList.remove("showing-megamenu");
      document.body.classList.remove("showing-popover");
      BN.dropdownService.hideDialogComplete();
      Object.keys(BN.onDropdownCloseFncList).forEach(function (k) {
        BN.onDropdownCloseFncList[k](e);
      });
    }
    mouseUpData = null;
    mouseDownData = null;
  });
  document.querySelectorAll("[close-dropdown]").forEach(function (closeBtn) {
    closeBtn.addEventListener("click", function (e) {
      BN.dropdownService.close(e);
      e.stopPropagation();
    });
  });
  document.querySelectorAll("[close-all-dropdown]").forEach(function (closeBtn) {
    closeBtn.addEventListener("click", function (e) {
      document.body.click();
    });
  });
});
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DropdownMenu = /*#__PURE__*/function () {
  function DropdownMenu(dropdownElement) {
    var _this = this;
    _classCallCheck(this, DropdownMenu);
    this.ignoreBlur = false;
    var vm = this;
    this.dropdownElement = dropdownElement;
    this.dropdownToggle = dropdownElement.querySelector(".bn-dropdown-menu-toggle");
    this.dropdownPanel = dropdownElement.querySelector(".bn-dropdown-menu-panel");
    this.dropdownPanel.addEventListener("mousedown", this.onDropdownPanelMousedown.bind(this));
    // this.dropdownToggle.addEventListener("blur", this.onToggleBlur.bind(this))
    this.dropdownToggle.addEventListener("click", this.onToggleClick.bind(this));
    this.dropdownToggle.addEventListener("keydown", this.onToggleKeyDown.bind(this));
    this.debounceSetPositionPanel = BN.debounce(this.setPositionPanel.bind(this), 150);
    this.dropdownItems = this.dropdownPanel.querySelectorAll(".bn-dropdown-menu-item").forEach(function (element) {
      element.addEventListener("click", function () {
        _this.updateState(false);
      });
    });
    this.dropdownElement.querySelectorAll(".bn-dropdown-menu-panel a").forEach(function (item) {
      item.addEventListener("blur", vm.onToggleBlur.bind(_this));
      item.addEventListener("keydown", _this.onToggleKeyDown.bind(_this));
    });
  }
  return _createClass(DropdownMenu, [{
    key: "onDropdownPanelMousedown",
    value: function onDropdownPanelMousedown() {
      this.ignoreBlur = true;
    }
  }, {
    key: "setPositionPanel",
    value: function setPositionPanel() {
      var posCursor = this.dropdownToggle.getBoundingClientRect();
      var posPanel = this.dropdownPanel.getBoundingClientRect();
      if (BN.wHeight - posCursor.y > posPanel.height) {
        this.dropdownPanel.style.top = "calc(100% + 0.4rem)";
        this.dropdownPanel.style.bottom = "auto";
      } else {
        this.dropdownPanel.style.top = "auto";
        this.dropdownPanel.style.bottom = "calc(100% + 0.2rem)";
      }
      if (BN.wWidth < posPanel.right) {
        this.dropdownPanel.style.left = "".concat(BN.wWidth - posPanel.right - 32, "px"); // 32 is gutter
      }
    }
  }, {
    key: "onToggleBlur",
    value: function onToggleBlur() {
      if (this.ignoreBlur) {
        this.ignoreBlur = false;
        return;
      }
      this.updateState(false);
    }
  }, {
    key: "onToggleClick",
    value: function onToggleClick() {
      this.updateState(!this.isOpen);
    }
  }, {
    key: "onToggleKeyDown",
    value: function onToggleKeyDown(event) {
      // const { key } = event
      // const max = this.selectElement.querySelectorAll(".bn-dropdown-menu-item").length - 1
      var action = this.getActionFromKey(event, this.open);
      switch (action) {
        // case SelectActions.Last: 
        case SelectActions.First:
          this.updateState(true);
          break;
        // case SelectActions.Next:
        // case SelectActions.Previous:
        // case SelectActions.PageUp:
        // case SelectActions.PageDown:
        //     event.preventDefault()
        //     return this.onOptionChange(getUpdatedIndex(this.activeIndex, max, action))
        // case SelectActions.CloseSelect:
        //     event.preventDefault()
        //     this.selectOption(this.activeIndex)
        case SelectActions.Close:
          event.preventDefault();
          return this.updateState(false);
        // case SelectActions.Type:
        //     return this.onComboType(key)
        case SelectActions.Open:
          event.preventDefault();
          return this.updateState(true);
      }
    }
  }, {
    key: "updateState",
    value: function updateState(open) {
      this.isOpen = open;
      if (open) {
        var _this$dropdownElement;
        this.dropdownElement.classList.add("active");
        this.setPositionPanel();
        window.addEventListener('scroll', this.debounceSetPositionPanel);
        (_this$dropdownElement = this.dropdownElement.querySelector(".bn-dropdown-menu-panel a")) === null || _this$dropdownElement === void 0 || _this$dropdownElement.focus();
      } else {
        window.removeEventListener('scroll', this.debounceSetPositionPanel);
        this.dropdownElement.classList.remove("active");
        this.dropdownToggle.focus();
      }
    }

    // map a key press to an action
  }, {
    key: "getActionFromKey",
    value: function getActionFromKey(event) {
      var key = event.key,
        altKey = event.altKey,
        ctrlKey = event.ctrlKey,
        metaKey = event.metaKey;
      var openKeys = ["ArrowDown", "ArrowUp", "Enter", " "]; // all keys that will do the default open action
      // handle opening when closed
      if (!this.isOpen && openKeys.includes(key)) {
        return SelectActions.Open;
      }

      // home and end move the selected option when open or closed
      if (key === "Home") {
        return SelectActions.First;
      }
      if (key === "End") {
        return SelectActions.Last;
      }

      // handle typing characters when open or closed
      if (key === "Backspace" || key === "Clear" || key.length === 1 && key !== " " && !altKey && !ctrlKey && !metaKey) {
        return SelectActions.Type;
      }

      // handle keys when open
      if (this.isOpen) {
        if (key === "ArrowUp" && altKey) {
          return SelectActions.CloseSelect;
        } else if (key === "ArrowDown" && !altKey) {
          return SelectActions.Next;
        } else if (key === "ArrowUp") {
          return SelectActions.Previous;
        } else if (key === "PageUp") {
          return SelectActions.PageUp;
        } else if (key === "PageDown") {
          return SelectActions.PageDown;
        } else if (key === "Escape") {
          return SelectActions.Close;
        } else if (key === "Enter" || key === " ") {
          return SelectActions.CloseSelect;
        }
      }
    }
  }]);
}();
BN.domContentLoadedFncList.push(function () {
  document.querySelectorAll(".bn-dropdown-menu").forEach(function (dropdownElm, index) {
    if (!dropdownElm.dropdown) {
      dropdownElm.dropdown = new DropdownMenu(dropdownElm);
    }
  });
});
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// mostly taken from WAI-ARIA Authoring guide: https://w3c.github.io/aria-practices/examples/combobox/combobox-select-only.html

// Save a list of named combobox actions, for future readability
var SelectActions = {
  Close: 0,
  CloseSelect: 1,
  First: 2,
  Last: 3,
  Next: 4,
  Open: 5,
  PageDown: 6,
  PageUp: 7,
  Previous: 8,
  OpenFirst: 9,
  OpenLast: 10
};
var SelectBox = /*#__PURE__*/function () {
  function SelectBox(comboboxElement) {
    var _this = this;
    _classCallCheck(this, SelectBox);
    this.isOpen = false;
    this.ignoreBlur = false;
    this.active_value = "";
    this.active_key = "";
    this.options = {};
    this.indexFocus = 0;
    this.indexSuggestion = 0;
    this.keyPressSuggestion = null;
    this.isSuggestioning = false;
    this.itemToShow = 5;
    this.comboboxElement = comboboxElement;
    this.disabled = comboboxElement.hasAttribute("disabled");
    this.selectElement = comboboxElement.querySelector("select");
    this.isReverseKeyValue = this.selectElement && this.selectElement.hasAttribute('data-phone-code');
    this.keepOpened = comboboxElement.hasAttribute('keep-opened');
    this.collapseOnMobile = comboboxElement.hasAttribute('collapse-mobile');
    this.selectCursor = comboboxElement.querySelector("[role=combobox]");
    this.selectPanel = comboboxElement.querySelector("[role=listbox]");
    this.selectCursor.addEventListener("blur", this.onComboBlur.bind(this));
    this.selectCursor.addEventListener("click", this.onComboClick.bind(this));
    this.selectCursor.addEventListener("keydown", this.onComboKeyDown.bind(this));
    this.selectCursor.addEventListener("focus", this.onComboFocus.bind(this));
    var vm = this;
    this.debounceSetPositionPanel = function () {
      vm.setPositionPanel();
    };
    this.selectElement.addEventListener('dataChanged', function (e) {
      _this.selectPanel.classList.add('show', 'visually-hidden');
      _this.selectPanel && (_this.selectPanel.scrollTop = 0);
      _this.selectPanel.classList.remove('show', 'visually-hidden');
      _this.initOptionTag();
      _this.selectElement.dispatchEvent(new Event('change', {
        bubbles: true
      }));
    });
    this.initOptionTag();
    if (this.disabled) {
      this.selectCursor.setAttribute("tabindex", "-1");
    }
    var input = this.selectPanel.querySelector('input');
    if (input) {
      input.addEventListener('mousedown', function (e) {
        _this.ignoreBlur = true;
      });
      input.addEventListener('keypress', function (e) {
        var key = e.which || e.keyCode;
        if (key === 13) {
          e.stopPropagation();
          _this.updateState(false);
        }
      });
      input.addEventListener('blur', function (e) {
        _this.updateState(false);
      });
    }
  }
  return _createClass(SelectBox, [{
    key: "replaceOptionSelect",
    value: function replaceOptionSelect(data) {
      var opt;
      this.selectElement.innerHTML = '';
      var _iterator = _createForOfIteratorHelper(data),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var key = _step.value;
          opt = document.createElement('option');
          opt.value = key[0];
          opt.innerHTML = key[0];
          this.selectElement.appendChild(opt);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "initOptionTag",
    value: function initOptionTag(data) {
      var _this2 = this;
      if (this.selectElement) {
        var vm = this;
        this.selectPanel.dataset.reset !== 'false' && (this.selectPanel.innerHTML = "");
        // init options in to select-panel
        var option_object = new Map();
        var addition_option_object = {};
        this.active_value = "";
        this.active_key = "";
        if (data) {
          var entriesObj = Object.entries(data);
          option_object = entriesObj.length ? new Map(entriesObj) : data;
          this.replaceOptionSelect(option_object);
        } else {
          this.selectElement.querySelectorAll("option").forEach(function (option, optionIdx) {
            var innerText = option.textContent;
            if (innerText) {
              var _option$dataset, _option$dataset2;
              var optionKeyName = _this2.isReverseKeyValue ? option.value : innerText;
              addition_option_object[optionKeyName] = {};
              addition_option_object[optionKeyName]['selected'] = option.selected;
              if (option.getAttribute('data-thumbnail')) {
                // option_object[optionKeyName] = option.innerHTML;
                option_object.set(optionKeyName, option.innerHTML);
                addition_option_object[optionKeyName]['data-thumbnail'] = option.getAttribute('data-thumbnail');
              } else {
                // option_object[innerText] = option.value
                option_object.set(innerText, option.value);
              }
              if ((_option$dataset = option.dataset) !== null && _option$dataset !== void 0 && _option$dataset.tooltip) {
                addition_option_object[optionKeyName]['tooltip'] = option.dataset.tooltip;
              }
              if ((_option$dataset2 = option.dataset) !== null && _option$dataset2 !== void 0 && _option$dataset2.additionalClass) {
                addition_option_object[optionKeyName]['additionalClass'] = option.dataset.additionalClass;
              }
            }
          });
        }
        this.options = option_object;
        var keys_option = Array.from(option_object.keys());
        keys_option.forEach(function (option, optionIdx) {
          var _addition_option_obje;
          var isSelected = !!((_addition_option_obje = addition_option_object[option]) !== null && _addition_option_obje !== void 0 && _addition_option_obje.selected);
          var optionElement = document.createElement("div"),
            value = option_object.get(option);
          optionElement.setAttribute("role", "option");
          optionElement.setAttribute("data-index", optionIdx);
          optionElement.setAttribute("data-value", value);
          if (addition_option_object[option] && addition_option_object[option]['tooltip']) {
            optionElement.setAttribute('data-tooltip', addition_option_object[option]['tooltip']);
            optionElement.setAttribute('data-tooltip-location', 'right');
          }
          optionElement.setAttribute("aria-selected", isSelected);
          if (isSelected) {
            _this2.comboboxElement.classList.remove('without-choosing');
            optionElement.setAttribute("aria-current", true);
            _this2.indexFocus = optionIdx;
          }
          if (addition_option_object[option]["additionalClass"]) {
            optionElement.classList.add(addition_option_object[option]["additionalClass"]);
          }
          var htmlOptionSelected = '';
          if (addition_option_object[option] && addition_option_object[option]['data-thumbnail']) {
            var html;
            if (window.lazySizes) {
              html = '<img class="lazyload" width="20" height="15" data-src="' + addition_option_object[option]['data-thumbnail'] + '" alt="">' + value;
            } else {
              html = '<img width="20" height="15" src="' + addition_option_object[option]['data-thumbnail'] + '" alt="">' + value;
            }
            optionElement.innerHTML = html;
            optionElement.setAttribute("title", value);
            optionElement.setAttribute("data-country", option);
            if (isSelected) {
              htmlOptionSelected = html;
            }
          } else {
            optionElement.innerText = option;
            optionElement.setAttribute("title", option);
            if (isSelected) {
              htmlOptionSelected = option;
            }
          }
          if (isSelected && _this2.selectCursor.dataset.setHtml !== 'false') {
            _this2.selectCursor.innerHTML = htmlOptionSelected;
          }
          optionElement.addEventListener("mousedown", function () {
            _this2.ignoreBlur = true;
            _this2.activeIndex = optionIdx;
          });
          optionElement.dataset.touchDirection = {
            direction: "up",
            currentCursorPos: 0
          };
          var touchDirection = null,
            touchStartPos = {},
            isTouching = false;
          optionElement.addEventListener("touchstart", function (e) {
            if (e.touches.length == 1) {
              isTouching = true;
              touchStartPos.y = e.touches[0].clientY;
            }
          }, {
            passive: false
          });
          optionElement.addEventListener("touchend", function (e) {
            if (e.touches.length == 1) {
              isTouching = false;
            }
          });
          optionElement.addEventListener("touchmove", function (e) {
            if (e.touches.length == 1) {
              touchDirection = touchStartPos.y > e.touches[0].clientY ? 'down' : 'up';
              touchStartPos.y = e.touches[0].clientY;
              if ((vm.selectPanel.scrollTop == 0 && touchDirection == 'up' || vm.selectPanel.scrollTop + vm.selectPanel.offsetHeight - 2 == vm.selectPanel.scrollHeight && touchDirection == 'down') && e.cancelable && isTouching) {
                e.preventDefault();
              }
            }
          }, {
            passive: false
          });
          optionElement.addEventListener("click", function (e) {
            e.stopPropagation();
            var _ref = e.detail || {},
              _ref$dispatchEvent = _ref.dispatchEvent,
              dispatchEvent = _ref$dispatchEvent === void 0 ? true : _ref$dispatchEvent;
            _this2.selectElement.setAttribute('is-dirty', true);
            if (_this2.selectElement.hasAttribute("data-append-html")) {
              _this2.selectOption(option, optionIdx, optionElement.innerHTML, dispatchEvent);
            } else {
              _this2.selectOption(option, optionIdx, null, dispatchEvent);
            }
            if (_this2.isSuggestioning) {
              _this2.setScrollToOptionSelected();
              _this2.isSuggestioning = false;
            } else {
              !_this2.keepOpened && _this2.updateState(false);
              _this2.resetSuggestion();
            }
            _this2.selectCursor.focus();
          });
          _this2.selectPanel.appendChild(optionElement);
        });
        !this.selectElement.addedEventChange && this.selectElement.addEventListener('change', function (e) {
          var _e$detail;
          var value = ((_e$detail = e.detail) === null || _e$detail === void 0 ? void 0 : _e$detail.value) !== undefined ? e.detail.value : _this2.selectElement.value;
          if (value) {
            var querySelector = '';
            if (_this2.comboboxElement.hasAttribute('data-phone-code')) {
              querySelector = "[role=\"option\"][data-country=\"".concat(value, "\"][aria-selected=\"false\"]");
            } else {
              querySelector = "[role=\"option\"][data-value=\"".concat(value, "\"][aria-selected=\"false\"]");
            }
            var optionEl = _this2.comboboxElement.querySelector(querySelector);
            if (optionEl) {
              optionEl.dispatchEvent(new CustomEvent('click', {
                detail: {
                  dispatchEvent: false
                }
              }));
            }
          } else {
            _this2.resetOption();
          }
          _this2.selectElement.addedEventChange = true;
        });
        this.allOptions = _toConsumableArray(this.selectPanel.querySelectorAll('[role="option"]'));
      }
    }
  }, {
    key: "closeOtherSelects",
    value: function closeOtherSelects() {
      var _this3 = this;
      document.querySelectorAll('.bn-select.opening').forEach(function (el) {
        if (el !== _this3.comboboxElement) {
          el.classList.remove('opening');
          el.select.isOpen = false;
          el.querySelector('[role="combobox"]').classList.remove('active');
          el.querySelector('[role="combobox"]').setAttribute('aria-expanded', 'false');
          el.querySelector('[role="listbox"]').classList.remove('show');
        }
      });
    }
  }, {
    key: "setPositionPanel",
    value: function setPositionPanel() {
      var gutter = 4;
      var posCursor = this.selectCursor.getBoundingClientRect();
      posCursor.y = posCursor.y + posCursor.height;
      this.selectPanel.style.maxHeight = 'px';
      this.selectPanel.style.width = "auto";
      var tmpWidth = this.selectPanel.offsetWidth < posCursor.width ? posCursor.width : this.selectPanel.offsetWidth + 8;
      tmpWidth = tmpWidth < BN.wWidth ? tmpWidth : BN.wWidth - 16;
      this.selectPanel.style.width = tmpWidth + "px";
      if (BN.wWidth < posCursor.x + tmpWidth || this.selectPanel.dataset.alignRight) {
        this.selectPanel.style.left = "".concat(posCursor.x + posCursor.width - tmpWidth + 8, "px");
      } else this.selectPanel.style.left = "".concat(posCursor.x, "px");
      if (BN.wHeight < posCursor.y + this.selectPanel.offsetHeight) {
        this.selectPanel.style.top = "auto";
        this.selectPanel.style.bottom = BN.wHeight - posCursor.y + posCursor.height + gutter + "px";
      } else {
        this.selectPanel.style.top = posCursor.y + gutter + "px";
        this.selectPanel.style.bottom = "auto";
      }
      if (posCursor.y < 0) posCursor.y = 0;
    }
  }, {
    key: "onComboClick",
    value: function onComboClick() {
      if (this.comboboxElement.hasAttribute("disabled")) return;
      this.closeOtherSelects();
      this.updateState(!this.isOpen);
    }
  }, {
    key: "selectOption",
    value: function selectOption(option, optionIdx, innerHTML) {
      var dispatchEvent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      this.comboboxElement.classList.remove("without-choosing");
      this.selectElement.value = this.isReverseKeyValue ? option : this.options.get(option);
      this.selectCursor.dataset.setHtml !== 'false' && (this.selectCursor.innerHTML = innerHTML ? innerHTML : option);
      this.selectCursor.setAttribute("title", option);
      this.active_value = this.isReverseKeyValue ? option : this.options.get(option);
      this.active_key = option;

      // update aria-selected
      var options = this.selectPanel.querySelectorAll("[role=option]");
      options.forEach(function (optionEl) {
        optionEl.setAttribute('aria-selected', 'false');
        optionEl.setAttribute('aria-current', 'false');
      });
      if ((options === null || options === void 0 ? void 0 : options[optionIdx]) === undefined) return;
      options[optionIdx].setAttribute('aria-selected', 'true');
      options[optionIdx].setAttribute('aria-current', 'true');
      this.focusOption(optionIdx);
      if (this.onChange) {
        this.onChange();
      }
      dispatchEvent && this.selectElement.dispatchEvent(new Event('change', {
        bubbles: true
      }));
      dispatchEvent && this.selectElement.dispatchEvent(new Event('input', {
        bubbles: true
      }));
    }
  }, {
    key: "debounceResetSuggestion",
    value: function debounceResetSuggestion() {
      var _this4 = this;
      return BN.throttle(function () {
        return _this4.resetSuggestion();
      }, 1000)();
    }
  }, {
    key: "resetSuggestion",
    value: function resetSuggestion() {
      this.indexSuggestion = 0;
      this.keyPressSuggestion = null;
      this.isSuggestioning = false;
    }
  }, {
    key: "onComboFocus",
    value: function onComboFocus() {
      this.resetSuggestion();
    }
  }, {
    key: "onComboBlur",
    value: function onComboBlur() {
      if (this.collapseOnMobile && BN.isMobile) return;
      if (this.ignoreBlur) {
        this.ignoreBlur = false;
        return;
      }
      this.updateState(false);
    }
  }, {
    key: "focusOption",
    value: function focusOption(index) {
      this.allOptions.forEach(function (option) {
        return option.setAttribute('aria-current', false);
      });
      var targetOption = this.allOptions[index];
      if (targetOption) {
        targetOption.setAttribute('aria-current', true);
      }
      this.indexFocus = index;
    }
  }, {
    key: "onComboKeyDown",
    value: function onComboKeyDown(event) {
      var _this$allOptions$this;
      var keyCode = event.which || event.keyCode;
      if (this.comboboxElement.hasAttribute("disabled")) return;
      var action = this.getActionFromKey(event);
      var keysAction = [BN.Key.HOME, BN.Key.END, BN.Key.ENTER, BN.Key.ARROW_DOWN, BN.Key.ARROW_UP, BN.Key.ESCAPE, BN.Key.SPACE, BN.Key.PAGE_DOWN, BN.Key.PAGE_UP];
      if (keysAction.indexOf(keyCode) > -1) {
        event.stopPropagation();
        event.preventDefault();
        switch (action) {
          case SelectActions.Open:
            this.updateState(true);
            break;
          case SelectActions.Close:
            this.updateState(false);
            break;
          case SelectActions.CloseSelect:
            (_this$allOptions$this = this.allOptions[this.indexFocus]) === null || _this$allOptions$this === void 0 || _this$allOptions$this.click();
            break;
          case SelectActions.First:
            this.focusOption(0);
            this.setScrollToOption(this.allOptions[0]);
            break;
          case SelectActions.OpenFirst:
            this.updateState(true);
            this.focusOption(0);
            this.setScrollToOption(this.allOptions[0], false);
            break;
          case SelectActions.Last:
            this.focusOption(this.allOptions.length - 1);
            this.setScrollToOption(this.allOptions[this.allOptions.length - 1]);
            break;
          case SelectActions.OpenLast:
            this.updateState(true);
            this.focusOption(this.allOptions.length - 1);
            this.setScrollToOption(this.allOptions[this.allOptions.length - 1], false);
            break;
          case SelectActions.Next:
            if (this.indexFocus < this.allOptions.length - 1) {
              this.focusOption(++this.indexFocus);
              this.setScrollToOption(this.allOptions[this.indexFocus]);
            }
            break;
          case SelectActions.Previous:
            if (this.indexFocus > 0) {
              this.focusOption(--this.indexFocus);
              this.setScrollToOption(this.allOptions[this.indexFocus]);
            }
            break;
          case SelectActions.PageUp:
            if (this.indexFocus > 0) {
              var index = this.indexFocus - this.itemToShow;
              index = index < 0 ? 0 : index;
              this.focusOption(index);
              this.setScrollToOption(this.allOptions[index]);
            }
            break;
          case SelectActions.PageDown:
            var optionsLength = this.allOptions.length;
            if (this.indexFocus < optionsLength - 1) {
              var _index = this.indexFocus + this.itemToShow;
              _index = _index > optionsLength - 1 ? optionsLength - 1 : _index;
              this.focusOption(_index);
              this.setScrollToOption(this.allOptions[_index]);
            }
            break;
          default:
            break;
        }
      } else {
        this.onKeyPressSuggestion(event);
      }
    }
  }, {
    key: "setScrollToOption",
    value: function setScrollToOption(optionEl) {
      var isSmooth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (optionEl) {
        var optionOffsetTop = optionEl.offsetTop,
          optionHeight = optionEl.clientHeight,
          panelHeight = this.selectPanel.clientHeight;
        var minScroll = this.selectPanel.scrollTop,
          maxScroll = minScroll + panelHeight;
        if (optionOffsetTop < minScroll) {
          this.selectPanel.scrollTo({
            top: optionOffsetTop,
            behavior: 'auto'
          });
        } else if (optionOffsetTop + optionHeight > maxScroll) {
          this.selectPanel.scrollTo({
            top: optionOffsetTop - panelHeight + optionHeight,
            behavior: 'auto'
          });
        }
      }
    }
  }, {
    key: "setScrollToOptionSelected",
    value: function setScrollToOptionSelected() {
      var isSmooth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var optionSelected = this.selectPanel.querySelector('[aria-selected="true"]');
      if (optionSelected) {
        var index = optionSelected.dataset.index;
        this.focusOption(index);
        this.setScrollToOption(optionSelected, isSmooth);
      } else {
        this.focusOption(0);
      }
    }
  }, {
    key: "updateState",
    value: function updateState(open) {
      this.isOpen = open;
      this.resetSuggestion();
      var extraClass = this.comboboxElement.dataset.extraClass;
      if (open) {
        var _this$selectPanel$que;
        this.selectCursor.classList.add("active");
        this.selectCursor.setAttribute('aria-expanded', 'true');
        this.comboboxElement.classList.add("opening");
        this.selectPanel.classList.add("show");
        this.setPositionPanel();
        window.addEventListener('scroll', this.debounceSetPositionPanel);
        this.setScrollToOptionSelected(false);
        document.body.classList.add("showing-dialog", "opening-selectbox");
        if (extraClass) {
          extraClass.split(",").forEach(function (item) {
            document.body.classList.add(item.trim());
          });
        }
        if (this.comboboxElement.closest('#dialog-variant')) {
          this.selectPanel.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center'
          });
        }
        (_this$selectPanel$que = this.selectPanel.querySelector('[role="option"]')) === null || _this$selectPanel$que === void 0 || _this$selectPanel$que.focus();
      } else {
        if (!BN.listDialogCursor.length) document.body.classList.remove("showing-dialog");
        document.body.classList.remove("opening-selectbox");
        if (extraClass) {
          extraClass.split(",").forEach(function (item) {
            document.body.classList.remove(item.trim());
          });
        }
        window.removeEventListener('scroll', this.debounceSetPositionPanel);
        this.selectPanel.classList.remove("show");
        this.selectCursor.classList.remove("active");
        this.selectCursor.setAttribute('aria-expanded', 'false');
        this.comboboxElement.classList.remove("opening");
        document.body.classList.remove("showing-megamenu");
      }
    }
  }, {
    key: "resetOption",
    value: function resetOption() {
      var _this$selectCursor$da;
      this.selectCursor.innerHTML = "<div class=\"bn-select__placeholder\">".concat((_this$selectCursor$da = this.selectCursor.dataset.placeholder) !== null && _this$selectCursor$da !== void 0 ? _this$selectCursor$da : '', "</div>");
      this.selectPanel.querySelectorAll('[role="option"][aria-selected="true"]').forEach(function (el) {
        el.ariaSelected = false;
      });
      this.selectPanel.querySelectorAll('[role="option"][aria-current="true"]').forEach(function (el) {
        el.ariaCurrent = false;
      });
      this.selectElement.value = '';
    }
  }, {
    key: "getOptionsSuggestion",
    value: function getOptionsSuggestion(_char) {
      var elOptions = _toConsumableArray(this.selectPanel.querySelectorAll('[role="option"]')),
        optionsSuggestion = elOptions.filter(function (elOption) {
          var _elOption$innerText;
          return elOption === null || elOption === void 0 || (_elOption$innerText = elOption.innerText) === null || _elOption$innerText === void 0 || (_elOption$innerText = _elOption$innerText.trim()) === null || _elOption$innerText === void 0 || (_elOption$innerText = _elOption$innerText.toLowerCase()) === null || _elOption$innerText === void 0 ? void 0 : _elOption$innerText.startsWith(_char);
        });
      return optionsSuggestion;
    }
  }, {
    key: "getCurrentIndexSuggestion",
    value: function getCurrentIndexSuggestion(_char2) {
      var index = 0;
      var optionSelected = this.selectPanel.querySelector('[aria-selected="true"]');
      if (optionSelected) {
        var _optionSelected$inner, _optionText$toLowerCa;
        var optionText = (_optionSelected$inner = optionSelected.innerText) === null || _optionSelected$inner === void 0 ? void 0 : _optionSelected$inner.trim();
        if (optionText !== null && optionText !== void 0 && (_optionText$toLowerCa = optionText.toLowerCase()) !== null && _optionText$toLowerCa !== void 0 && _optionText$toLowerCa.startsWith(_char2)) {
          var optionsSuggestion = this.getOptionsSuggestion(_char2);
          index = optionsSuggestion.reduce(function (acc, cur, index) {
            var _cur$innerText;
            if (((_cur$innerText = cur.innerText) === null || _cur$innerText === void 0 ? void 0 : _cur$innerText.trim()) === optionText) {
              acc = index + 1;
            }
            return acc;
          }, 0);
          if (index > optionsSuggestion.length - 1) {
            index = 0;
          }
        }
      }
      return index;
    }
  }, {
    key: "onKeyPressSuggestion",
    value: function onKeyPressSuggestion(e) {
      var _char3 = String.fromCharCode(e.keyCode).toLowerCase();
      this.debounceResetSuggestion();
      if (!_char3 || this.keyPressSuggestion !== null && _char3 !== this.keyPressSuggestion) {
        return;
      }
      this.keyPressSuggestion = _char3;
      this.indexSuggestion = this.getCurrentIndexSuggestion(_char3);
      var itemsSuggestion = this.getOptionsSuggestion(_char3),
        currentItemSuggestion = itemsSuggestion === null || itemsSuggestion === void 0 ? void 0 : itemsSuggestion[this.indexSuggestion];
      if (currentItemSuggestion) {
        this.isSuggestioning = true;
        currentItemSuggestion.click();
        this.indexSuggestion++;
      }
    }
    // map a key press to an action
  }, {
    key: "getActionFromKey",
    value: function getActionFromKey(event) {
      var altKey = event.altKey;
      var keyCode = event.which || event.keyCode;
      switch (keyCode) {
        case BN.Key.ESCAPE:
          return this.isOpen ? SelectActions.Close : null;
        case BN.Key.ENTER:
          return this.isOpen ? SelectActions.CloseSelect : SelectActions.Open;
        case BN.Key.ARROW_DOWN:
          if (altKey) {
            return this.isOpen ? null : SelectActions.Open;
          } else {
            if (this.isOpen) {
              return SelectActions.Next;
            } else {
              return SelectActions.Open;
            }
          }
        case BN.Key.ARROW_UP:
          if (altKey) {
            return this.isOpen ? SelectActions.CloseSelect : SelectActions.Open;
          } else {
            if (this.isOpen) {
              return SelectActions.Previous;
            } else {
              return SelectActions.Open;
            }
          }
        case BN.Key.SPACE:
          return this.isOpen ? SelectActions.CloseSelect : SelectActions.Open;
        case BN.Key.PAGE_UP:
          return this.isOpen ? SelectActions.PageUp : null;
        case BN.Key.PAGE_DOWN:
          return this.isOpen ? SelectActions.PageDown : null;
        case BN.Key.HOME:
          return this.isOpen ? SelectActions.First : SelectActions.OpenFirst;
        case BN.Key.END:
          return this.isOpen ? SelectActions.Last : SelectActions.OpenLast;
        default:
          return null;
      }
    }
  }, {
    key: "updateStateDisabled",
    value: function updateStateDisabled(value) {
      if (value) {
        this.comboboxElement.setAttribute("disabled", "");
        this.selectCursor.setAttribute("tabindex", "0");
        this.disabled = true;
      } else {
        this.comboboxElement.removeAttribute("disabled");
        this.selectCursor.setAttribute("tabindex", "-1");
        this.disabled = false;
      }
    }
  }]);
}();
BN.domContentLoadedFncList.push(function () {
  document.querySelectorAll(".bn-select:not(.lazy-init-select)").forEach(function (selectElm, index) {
    if (!selectElm.select) {
      selectElm.select = new SelectBox(selectElm);
    }
  });
});
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CollapseService = /*#__PURE__*/function () {
  function CollapseService() {
    _classCallCheck(this, CollapseService);
    this.init("bn-toggle-btn");
  }
  return _createClass(CollapseService, [{
    key: "removeProperty",
    value: function removeProperty(target) {
      for (var _len = arguments.length, listProperties = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        listProperties[_key - 1] = arguments[_key];
      }
      listProperties.forEach(function (prop) {
        target.style.removeProperty(prop);
      });
    }
  }, {
    key: "setProperty",
    value: function setProperty(target) {
      target.style.overflow = 'hidden';
      target.style.height = 0;
      target.style.paddingTop = 0;
      target.style.paddingBottom = 0;
      target.style.marginTop = 0;
      target.style.marginBottom = 0;
    }
  }, {
    key: "init",
    value: function init(queryElm) {
      var vm = this;
      BN.onClickDocumentFnList.collapseServiceInit = function (ev) {
        var _currentElm$classList;
        var currentElm = ev.target;
        if (currentElm !== null && currentElm !== void 0 && (_currentElm$classList = currentElm.classList) !== null && _currentElm$classList !== void 0 && _currentElm$classList.contains(queryElm)) vm.triggerToggleClick(currentElm.id, currentElm.dataset.target);
      };
    }
  }, {
    key: "slideUp",
    value: function slideUp(buttonId, target) {
      var _this = this;
      var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 500;
      var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      if (typeof target == "string") target = document.querySelector(target);
      typeof callback === 'function' && callback({
        target: target,
        status: 'transition-start',
        type: 'close'
      });
      target.style.height = target.offsetHeight + 'px';
      target.offsetHeight;
      this.setProperty(target);
      var buttonElm = document.getElementById(buttonId);
      if (buttonElm.querySelector('.collapse-icon')) {
        buttonElm.querySelector('.collapse-icon').classList.remove('rotate180');
      }
      buttonElm.classList.remove('active');
      buttonElm.setAttribute("aria-expanded", false);
      window.setTimeout(function () {
        target.style.display = 'none';
        _this.removeProperty(target, 'height', 'padding-top', 'padding-bottom', 'margin-top', 'margin-bottom', 'overflow', 'transition-duration', 'transition-property');
        typeof callback === 'function' && callback({
          target: target,
          status: 'transition-end',
          type: 'close'
        });
      }, duration);
    }
  }, {
    key: "slideDown",
    value: function slideDown(buttonId, target) {
      var _this2 = this;
      var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 500;
      var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      if (typeof target == "string") {
        target = document.querySelector(target);
      }

      // Check if target exists
      if (!target || !target.style) {
        return;
      }
      typeof callback === 'function' && callback({
        target: target,
        status: 'transition-start',
        type: 'open'
      });
      target.style.removeProperty('display');
      var buttonElm = document.getElementById(buttonId);
      if (buttonElm.classList.contains("active")) return;
      if (buttonElm.querySelector('.collapse-icon')) {
        buttonElm.querySelector('.collapse-icon').classList.add('rotate180');
      }
      target.style.display = 'block';
      buttonElm.classList.add('active');
      buttonElm.setAttribute("aria-expanded", true);
      var height = target.offsetHeight;
      this.setProperty(target);
      target.offsetHeight;
      target.style.height = height + 'px';
      this.removeProperty(target, 'padding-top', 'padding-bottom', 'margin-top', 'margin-bottom');
      window.setTimeout(function () {
        _this2.removeProperty(target, 'height', 'overflow', 'transition-duration', 'transition-property');
        typeof callback === 'function' && callback({
          target: target,
          status: 'transition-end',
          type: 'open'
        });
      }, duration);
    }
  }, {
    key: "slideToggle",
    value: function slideToggle(buttonId, target) {
      var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 500;
      var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      target.style.transitionProperty = 'height, margin, padding';
      target.style.transitionDuration = duration + 'ms';
      target.style.boxSizing = 'border-box';
      if (window.getComputedStyle(target).display === 'none') {
        return this.slideDown(buttonId, target, duration, callback);
      } else {
        return this.slideUp(buttonId, target, duration, callback);
      }
    }
  }, {
    key: "toggleClick",
    value: function toggleClick(buttonId, targetId) {
      var _this3 = this;
      var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      if (document.getElementById(buttonId) && document.getElementById(targetId)) {
        document.getElementById(buttonId).addEventListener('click', function () {
          return _this3.slideToggle(buttonId, document.getElementById(targetId), 400, callback);
        });
      }
    }
  }, {
    key: "triggerToggleClick",
    value: function triggerToggleClick(buttonId, targetId) {
      var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      if (document.getElementById(buttonId) && document.getElementById(targetId)) {
        this.slideToggle(buttonId, document.getElementById(targetId), 400, callback);
      }
    }
  }]);
}();
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Focus = /*#__PURE__*/function () {
  function Focus() {
    _classCallCheck(this, Focus);
  }
  return _createClass(Focus, [{
    key: "addEventFocus",
    value: function addEventFocus(listCurrentSelectors, listNextSelectors) {
      var listCurrentEl = document.querySelectorAll(listCurrentSelectors);
      var listNextEl = document.querySelectorAll(listNextSelectors);
      if (listCurrentEl.length) {
        var currentEl = listCurrentEl[listCurrentEl.length - 1];
        var nextEl = listNextEl[0];
        var KEYCODE_TAB = 9;
        currentEl.addEventListener("keydown", function (evt) {
          //handle Tab but not Shift + Tab event for current element
          if (evt.keyCode == KEYCODE_TAB && !evt.shiftKey) {
            if (listNextEl.length) {
              nextEl.focus();
              nextEl.addEventListener("keydown", function (evtNext) {
                //handle Shift + Tab event for next element
                if (evtNext.keyCode == KEYCODE_TAB && evtNext.shiftKey) {
                  currentEl.focus();
                  evtNext.preventDefault();
                }
              });
            }
            evt.preventDefault();
          }
        });
      }
    }
  }, {
    key: "addEventFocusForMultiBlock",
    value: function addEventFocusForMultiBlock() {
      if (arguments.length > 1) {
        for (var i = 0; i < arguments.length - 1; i++) {
          this.addEventFocus(i < 0 || arguments.length <= i ? undefined : arguments[i], i + 1 < 0 || arguments.length <= i + 1 ? undefined : arguments[i + 1]);
        }
      }
    }
  }]);
}();
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var HttpService = /*#__PURE__*/function () {
  function HttpService() {
    _classCallCheck(this, HttpService);
    _defineProperty(this, "METHODS", {
      DELETE: "delete",
      GET: "get",
      PUT: "put",
      POST: "post",
      UPLOAD: "uploadFile",
      PATCH: "patch"
    });
  }
  return _createClass(HttpService, [{
    key: "sendRequest",
    value: function sendRequest(method, url) {
      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var requestHeaders = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var isAsync = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
      var xhr = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
      return new Promise(function (resolve, reject) {
        xhr = xhr || new XMLHttpRequest();
        if (method == "POST_FILE") {
          xhr.open("POST", url, isAsync);
          /*xhr.setRequestHeader('Content-type', 'multipart/form-data');*/
        } else {
          xhr.open(method, url, isAsync);
          xhr.setRequestHeader('Content-type', 'application/json; charset=UTF-8');
        }
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        //
        var body = document.getElementsByTagName('body');
        var fromPage = 0;
        if (body != undefined && body.length > 0) {
          fromPage = body[0].getAttribute('p');
        }
        xhr.setRequestHeader('bro-p', fromPage);
        if (requestHeaders) {
          Object.keys(requestHeaders).forEach(function (headerKey) {
            xhr.setRequestHeader(headerKey, requestHeaders[headerKey]);
          });
        }

        //Add default forgery token to header of post method
        if (!requestHeaders || !requestHeaders.hasOwnProperty('RequestVerificationToken')) {
          var tokens = document.getElementsByName('__RequestVerificationToken');
          if (tokens != null && tokens != undefined && tokens.length > 0) {
            var _tokens$;
            xhr.setRequestHeader('RequestVerificationToken', (_tokens$ = tokens[0]) === null || _tokens$ === void 0 ? void 0 : _tokens$.value);
          }
        }
        xhr.onload = function () {
          try {
            if (xhr.status >= 200 && xhr.status < 300) {
              resolve(xhr.responseText ? JSON.parse(xhr.responseText) : {});
            } else {
              var resError = {};
              resError = JSON.parse(xhr.responseText);
              resolve(Object.assign({
                status: xhr.status,
                statusText: xhr.statusText,
                error: true
              }, resError));
            }
          } catch (error) {
            resolve({
              status: xhr.status,
              statusText: xhr.statusText,
              error: true
            });
            console.error("Content is malformed ", error);
          }
        };
        xhr.onerror = function (e) {
          reject({
            status: xhr.status,
            statusText: xhr.statusText
          });
        };
        if (method == "POST_FILE") {
          xhr.send(data);
        } else {
          xhr.send(data ? JSON.stringify(data) : null);
        }
      });
    }
  }, {
    key: "getHtmlContent",
    value: function getHtmlContent(url) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var requestHeaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var isAsync = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, isAsync);
        xhr.setRequestHeader('Accept', 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.9');
        if (requestHeaders) {
          Object.keys(requestHeaders).forEach(function (headerKey) {
            xhr.setRequestHeader(headerKey, requestHeaders['headerKey']);
          });
        }
        xhr.onload = function () {
          if (xhr.status >= 200 && xhr.status < 300) {
            resolve(xhr.responseText);
          } else {
            reject({
              status: xhr.status,
              statusText: xhr.statusText
            });
          }
        };
        xhr.onerror = function () {
          reject({
            status: xhr.status,
            statusText: xhr.statusText
          });
        };
        xhr.send(JSON.stringify(data));
      });
    }
  }, {
    key: "get",
    value: function get(url, data, requestHeaders) {
      var isAsync = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var xhr = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      return this.sendRequest('GET', url, data, requestHeaders, isAsync, xhr);
    }
  }, {
    key: "post",
    value: function post(url, data, requestHeaders) {
      var isAsync = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var xhr = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      return this.sendRequest('POST', url, data, requestHeaders, isAsync, xhr);
    }
  }, {
    key: "patch",
    value: function patch(url, data, requestHeaders) {
      var isAsync = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var xhr = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      return this.sendRequest('PATCH', url, data, requestHeaders, isAsync, xhr);
    }
  }, {
    key: "uploadFile",
    value: function uploadFile(url, data, requestHeaders) {
      var isAsync = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var xhr = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      return this.sendRequest('POST_FILE', url, data, requestHeaders, isAsync, xhr);
    }
  }, {
    key: "put",
    value: function put(url, data, requestHeaders) {
      var isAsync = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var xhr = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      return this.sendRequest('PUT', url, data, requestHeaders, isAsync, xhr);
    }
  }, {
    key: "update",
    value: function update(url, data, requestHeaders) {
      var isAsync = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var xhr = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      return this.sendRequest('PUT', url, data, requestHeaders, isAsync, xhr);
    }
  }, {
    key: "delete",
    value: function _delete(url, data, requestHeaders) {
      var isAsync = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var xhr = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      return this.sendRequest('DELETE', url, data, requestHeaders, isAsync, xhr);
    }
  }, {
    key: "getPromise",
    value: function getPromise(method, endPoint, data, isAsync, doNotShowErrorMSG) {
      var self = this;
      return new Promise(function (resolve, reject) {
        self[method](endPoint, data, null, isAsync).then(function (res) {
          if (!doNotShowErrorMSG && res.error && res.message) {
            BN.toastService.displayToast(res.message, "error");
          }
          resolve(res);
        })["catch"](function (e) {
          BN.toastService.displayToast("Something wrong!", "error");
          console.log(e);
          reject(e);
        });
      });
    }
  }, {
    key: "getPromiseWithoutMSG",
    value: function getPromiseWithoutMSG(method, endPoint, data, isAsync) {
      return this.getPromise(method, endPoint, data, isAsync, true);
    }
  }]);
}();
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Input = /*#__PURE__*/function () {
  function Input() {
    _classCallCheck(this, Input);
    _defineProperty(this, "zIndexInputRange", 3);
    _defineProperty(this, "configRangeList", {});
  }
  return _createClass(Input, [{
    key: "addEventDisplayPassword",
    value: function addEventDisplayPassword(inputId, displayButtonId, parentElem) {
      var showText = "Show";
      var hideText = "Hide";
      var displayButtonEl = document.getElementById(displayButtonId);
      var inputEl = document.getElementById(inputId);
      if (parentElem) {
        displayButtonEl = parentElem.querySelector(".".concat(displayButtonId));
        inputEl = parentElem.querySelector(".".concat(inputId));
      }
      displayButtonEl.addEventListener('click', function (evt) {
        if (inputEl.type === "password") {
          inputEl.type = "text";
          evt.target.innerHTML = hideText;
        } else {
          inputEl.type = "password";
          evt.target.innerHTML = showText;
        }
      });
      ['change', 'keypress', 'keyup', 'paste'].forEach(function (eventName) {
        inputEl.addEventListener(eventName, function (evt) {
          var _evt$target$value;
          var pasteText = '';
          if (eventName == 'paste') {
            pasteText = (evt.originalEvent || evt).clipboardData.getData('text/plain');
          }
          displayButtonEl.style.display = ((_evt$target$value = evt.target.value) === null || _evt$target$value === void 0 ? void 0 : _evt$target$value.length) > 0 || pasteText.length > 0 ? "block" : "none";
        });
      });
      document.addEventListener('click', function (evt) {
        if (!parentElem && ![inputId, displayButtonId].includes(evt.target.id) || parentElem && !evt.target.classList.contains(inputId) && !evt.target.classList.contains(displayButtonId)) {
          inputEl.type = "password";
          displayButtonEl.innerHTML = showText;
        }
      });
    }
  }, {
    key: "setClassPasswordCriteria",
    value: function setClassPasswordCriteria(elem, flag) {
      if (elem) {
        var classInActive = 'password-criteria--inactive';
        var svgElem = elem.querySelector('svg use');
        if (flag == 1) {
          elem.classList.remove(classInActive);
          svgElem.setAttribute('xlink:href', '#svg_check-no-round');
        } else {
          elem.classList.add(classInActive);
          svgElem.setAttribute('xlink:href', '#svg_close_login');
        }
      }
    }
  }, {
    key: "checkStrength",
    value: function checkStrength(password) {
      var strength = 0;
      var hasAllCaseChar = 0;
      var hasNumberSpecialChar = 0;
      var hasMoreEightChar = 0;

      //If password contains both lower and uppercase characters
      if (password.match(BN.Regex['allCaseCharacter'])) {
        strength += 1;
        hasAllCaseChar = 1;
      }

      //If it has numbers and characters
      if (password.match(BN.Regex['number'])) {
        strength += 1;
        hasNumberSpecialChar += 0.5;
      }

      //If it has one special character
      if (password.match(BN.Regex['specialCharacter'])) {
        strength += 1;
        hasNumberSpecialChar += 0.5;
      }

      //If password is greater or equal 8
      if (password.length > 7) {
        strength += 1;
        hasMoreEightChar = 1;
      }
      this.setClassPasswordCriteria(document.querySelector('#hasAllCase'), hasAllCaseChar);
      this.setClassPasswordCriteria(document.querySelector('#hasMoreEightChar'), hasMoreEightChar);
      this.setClassPasswordCriteria(document.querySelector('#hasNumberSpecialChar'), hasNumberSpecialChar);
      return strength;
    }
  }, {
    key: "addEventInputPasswoord",
    value: function addEventInputPasswoord(formGroupId, inputId, displayButtonId) {
      var _this = this;
      var showPassStrength = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var isMobile = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      this.addEventDisplayPassword(inputId, displayButtonId);
      if (!isMobile) {
        isMobile = BN.checkIsMobile();
      }
      if (showPassStrength) {
        ['input', 'change', 'keypress', 'keyup'].forEach(function (eventName) {
          document.getElementById(inputId).addEventListener(eventName, function (evt) {
            var _evt$target$value2;
            var strengthElemSelector = ".custom-form-group__strength";
            var formGroupElem = document.getElementById(formGroupId);
            var strengthElem = formGroupElem.querySelector(strengthElemSelector);
            var strengthBarElem = formGroupElem.querySelector("".concat(strengthElemSelector, "__bar"));
            var strengthNameElem = formGroupElem.querySelector("".concat(strengthElemSelector, "__name"));
            var labelStrengthMobile = formGroupElem.querySelector(".custom-form-group__label__right");

            // validate strength of password
            var strength = _this.checkStrength(evt.target.value);
            if (((_evt$target$value2 = evt.target.value) === null || _evt$target$value2 === void 0 ? void 0 : _evt$target$value2.length) > 0) {
              var classSuffix = "--error";
              var textLabel = "Poor";
              if (strength == 3) {
                classSuffix = "--warning";
                textLabel = "Average";
              }
              if (strength == 4) {
                classSuffix = "--success";
                textLabel = "Strong";
              }
              var strengthBarLevelElem = formGroupElem.querySelector(".strength__bar__level");
              strengthBarLevelElem.classList.replace(strengthBarLevelElem.classList[1], "strength__bar__level".concat(classSuffix));
              strengthElem.style.display = 'flex';
              strengthBarElem.style.display = 'flex';
              if (isMobile) {
                // mobile screen
                strengthNameElem.style.display = 'none';
                labelStrengthMobile.style.display = 'block';
                labelStrengthMobile.classList.replace(labelStrengthMobile.classList[1], "custom-form-group__label__right".concat(classSuffix));
                labelStrengthMobile.innerText = textLabel;
              } else {
                // desktop screen
                strengthNameElem.style.display = 'flex';
                strengthNameElem.classList.replace(strengthNameElem.classList[2], "strength__name".concat(classSuffix));
                strengthNameElem.innerText = textLabel;
                labelStrengthMobile.style.display = 'none';
              }
            } else {
              // if input is empty
              labelStrengthMobile.style.display = 'none';
              strengthBarElem.style.display = 'none';
              strengthNameElem.style.display = 'none';
            }
          });
        });
      }
    }
  }, {
    key: "checkRequiredInputField",
    value: function checkRequiredInputField(listInputElems, errMsg, errorElem) {
      var _this2 = this;
      var formValid = true;
      listInputElems.forEach(function (elem) {
        var _elem$previousSibling;
        var textErrorElem = _this2.getTextErrorElement(elem, errorElem);
        var message = elem.getAttribute('err-msg') ? elem.getAttribute('err-msg') : errMsg;
        var inputValue = elem.value.trim();
        var onlyValidateNonAscii = elem.hasAttribute("non-ascii-required");
        var hasNonAsciiChar = elem.name != "Password2" && (!elem.hasAttribute("non-ascii-allowed") || elem.getAttribute("non-ascii-allowed") != "true") && inputValue.length && inputValue.match(BN.Regex['nonASCII']);
        if ((inputValue.length < 1 && !onlyValidateNonAscii || hasNonAsciiChar) && !elem.classList.contains('hide')) {
          formValid = false;
          if (hasNonAsciiChar) {
            message = window.nonAsciiMessage ? window.nonAsciiMessage : "Not allow non-ASCII";
          }
          elem.classList.add('input-error');
        } else {
          message = "";
          elem.classList.remove('input-error');
        }
        if (textErrorElem && (((_elem$previousSibling = elem.previousSibling) === null || _elem$previousSibling === void 0 ? void 0 : _elem$previousSibling.tagName) != "INPUT" || !elem.previousSibling.classList.contains("input-error"))) {
          textErrorElem.innerText = message;
        }
      });
      return formValid;
    }
  }, {
    key: "checkRequiredInputAllFields",
    value: function checkRequiredInputAllFields(listInputElems, errMsg, errorElem) {
      var formValid = true;
      listInputElems.forEach(function (elem) {
        var inputValue = elem.value.trim();
        if (inputValue.length < 1 && !elem.classList.contains('hide')) {
          formValid = false;
          elem.classList.add('input-error');
        } else {
          elem.classList.remove('input-error');
        }
      });
      if (errorElem) {
        if (formValid) {
          errorElem.innerText = "";
        } else {
          errorElem.innerText = errMsg;
        }
      }
      return formValid;
    }
  }, {
    key: "resetTextError",
    value: function resetTextError(listInputElems, errorElem, generalMsgElem) {
      var _this3 = this;
      listInputElems.forEach(function (elem) {
        var textErrorElem = _this3.getTextErrorElement(elem, errorElem);
        var isAsciiCharacterAllowed = elem.hasAttribute("non-ascii-allowed") && elem.getAttribute("non-ascii-allowed") == "true";
        ['keyup', 'blur'].forEach(function (eventName) {
          elem.addEventListener(eventName, function (e) {
            if (elem.value.trim().length > 0 && e.key != BN.KeyName["enter"]) {
              var message = "";
              if (!isAsciiCharacterAllowed && elem.value.trim().match(BN.Regex['nonASCII'])) {
                message = window.nonAsciiMessage ? window.nonAsciiMessage : "Not allow non-ASCII";
                elem.classList.add('input-error');
              }
              if (generalMsgElem || textErrorElem) {
                var _elem$previousSibling2, _elem$nextElementSibl;
                if (generalMsgElem && (!elem.closest('.login__form') || elem.getAttribute('type') == "password")) {
                  generalMsgElem.innerText = message;
                }
                if (textErrorElem && !(((_elem$previousSibling2 = elem.previousSibling) === null || _elem$previousSibling2 === void 0 ? void 0 : _elem$previousSibling2.tagName) == "INPUT" && elem.previousSibling.classList.contains("input-error") || ((_elem$nextElementSibl = elem.nextElementSibling) === null || _elem$nextElementSibl === void 0 ? void 0 : _elem$nextElementSibl.tagName) == "INPUT" && elem.nextElementSibling.classList.contains("input-error"))) {
                  textErrorElem.innerText = message;
                }
                !message && elem.classList.remove('input-error');
              }
            }
          });
        });
      });
    }
  }, {
    key: "resetTextOtpError",
    value: function resetTextOtpError(listInputElems, errorElem, generalMsgElem) {
      var _this4 = this;
      listInputElems.forEach(function (elem) {
        var textErrorElem = _this4.getTextErrorElement(elem, errorElem);
        ['change', 'keydown'].forEach(function (eventName) {
          elem.addEventListener(eventName, function () {
            if (elem.value.trim().length > 0 || eventName == 'keyup') {
              if (generalMsgElem) {
                generalMsgElem.innerText = '';
              }
              if (textErrorElem) {
                textErrorElem.innerText = '';
              }
              elem.classList.remove('input-error');
            }
          });
        });
      });
    }
  }, {
    key: "getTextErrorElement",
    value: function getTextErrorElement(inputEl, errEl) {
      var textErrorElem = inputEl.name == 'Password' ? errEl : inputEl.nextElementSibling;
      if (textErrorElem && !textErrorElem.classList.contains('text-error')) {
        var loopIndex = 0;
        while (textErrorElem && !textErrorElem.classList.contains('text-error') && loopIndex < 3) {
          textErrorElem = textErrorElem.nextElementSibling;
          loopIndex += 1;
        }
      }
      return textErrorElem;
    }
  }, {
    key: "formatMoney",
    value: function formatMoney(money) {
      var format = '${{amount}}';
      money = parseFloat(money).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return format.replace(/{{amount}}/, money);
    }
  }, {
    key: "setInputMoneys",
    value: function setInputMoneys(configRange, money, type) {
      if (configRange !== null && configRange !== void 0 && configRange.inputRangeElm) {
        var _configRange$inputRan, _configRange$inputRan2, _configRange$inputRan3, _configRange$inputRan4;
        var min = (_configRange$inputRan = (_configRange$inputRan2 = configRange.inputRangeElm.dataset.priceMin) === null || _configRange$inputRan2 === void 0 ? void 0 : _configRange$inputRan2.trim()) !== null && _configRange$inputRan !== void 0 ? _configRange$inputRan : 0,
          max = (_configRange$inputRan3 = (_configRange$inputRan4 = configRange.inputRangeElm.dataset.priceMax) === null || _configRange$inputRan4 === void 0 ? void 0 : _configRange$inputRan4.trim()) !== null && _configRange$inputRan3 !== void 0 ? _configRange$inputRan3 : 100;
        var value = configRange.inputRangeElm.value,
          values = value.split('-');
        values[type] = BN.formatPrice(money);
        if (type === 0) {
          var _values$;
          values[1] = ((_values$ = values[1]) === null || _values$ === void 0 ? void 0 : _values$.trim()) || BN.formatPrice(max);
        } else {
          var _values$2;
          values[0] = ((_values$2 = values[0]) === null || _values$2 === void 0 ? void 0 : _values$2.trim()) || BN.formatPrice(min);
        }
        configRange.inputRangeElm.value = values.join('-');
      }
    }
  }, {
    key: "onChangeEventInputRangeMax",
    value: function onChangeEventInputRangeMax(configRange) {
      var init = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var elem = configRange.maxInputElm;
      var minValue = parseFloat(elem.min);
      var valueInputMin;
      if (init) {
        valueInputMin = parseFloat(configRange.minInputElm.getAttribute('value') || configRange.minInputElm.value);
        elem.value = Math.max(elem.getAttribute('value') || elem.value, valueInputMin);
      } else {
        valueInputMin = parseFloat(configRange.minInputElm.value);
        if (parseFloat(elem.value) < valueInputMin) elem.value = valueInputMin + 1;
      }
      if (valueInputMin == minValue) {
        elem.style.zIndex = this.zIndexInputRange + 1;
        configRange.maxInputElm.style.zIndex = this.zIndexInputRange;
      } else {
        elem.style.zIndex = this.zIndexInputRange;
      }

      // get percentage that value occupies
      var value = 100 / (parseFloat(elem.max) - parseFloat(elem.min)) * (parseFloat(elem.value) - parseFloat(elem.min));
      configRange.inverseRightElm.style.width = "".concat(100 - value, "%");
      configRange.mainRangeElm.style.right = "".concat(100 - value, "%");
      configRange.thumbRightElm.style.left = "".concat(value, "%");
      configRange.maxElm.innerHTML = BN.formatPrice(elem.value);
      !init && this.setInputMoneys(configRange, elem.value, 1);
    }
  }, {
    key: "onChangeEventInputRangeMin",
    value: function onChangeEventInputRangeMin(configRange) {
      var init = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var elem = configRange.minInputElm;
      var maxValue = parseFloat(elem.max);
      var valueInputMax;
      if (init) {
        valueInputMax = parseFloat(configRange.maxInputElm.getAttribute('value') || configRange.maxInputElm.value);
        elem.value = Math.min(elem.getAttribute('value') || elem.value, valueInputMax);
      } else {
        valueInputMax = parseFloat(configRange.maxInputElm.value);
        if (parseFloat(elem.value) > valueInputMax) elem.value = valueInputMax - 1;
      }
      if (valueInputMax == maxValue) {
        elem.style.zIndex = this.zIndexInputRange + 1;
        configRange.maxInputElm.style.zIndex = this.zIndexInputRange;
      } else {
        elem.style.zIndex = this.zIndexInputRange;
      }
      // get percentage that value occupies
      var value = 100 / (parseFloat(elem.max) - parseFloat(elem.min)) * (parseFloat(elem.value) - parseFloat(elem.min));
      configRange.inverseLeftElm.style.width = "".concat(value, "%");
      configRange.mainRangeElm.style.left = "".concat(value, "%");
      configRange.thumbLeftElm.style.left = "".concat(value, "%");
      configRange.minElm.innerHTML = BN.formatPrice(elem.value);
      !init && this.setInputMoneys(configRange, elem.value, 0);
    }
  }, {
    key: "addEventInputRange",
    value: function addEventInputRange(sliderId, isInputMin) {
      var init = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      document.querySelector("#".concat(sliderId)).inited = true;
      var self = this,
        configRange = this.configRangeList[sliderId];
      if (!configRange || !configRange.minElm || !configRange.maxElm || !configRange.minInputElm || !configRange.maxInputElm || !configRange.mainRangeElm || !configRange.inputRangeElm || !configRange.inverseLeftElm || !configRange.inverseRightElm || !configRange.thumbLeftElm || !configRange.thumbRightElm) return;
      configRange.minElm.addEventListener("keydown", function (e) {
        if (e.key === "Enter") e.preventDefault();
      });
      configRange.maxElm.addEventListener("keydown", function (e) {
        if (e.key === "Enter") e.preventDefault();
      });
      configRange.minElm.addEventListener("focus", function (e) {
        var _configRange = self.configRangeList[e.target.closest(".multi-range-slider").id];
        _configRange.minElm.innerHTML = _configRange.minInputElm.value;
        BN.selectElementContents(_configRange.minElm);
      });
      configRange.minElm.addEventListener("blur", function (e) {
        var _configRange = self.configRangeList[e.target.closest(".multi-range-slider").id];
        var oldValue = _configRange.minInputElm.value;
        if (!isNaN(_configRange.minElm.innerHTML) && parseFloat(_configRange.minElm.innerHTML) <= parseFloat(_configRange.maxInputElm.value)) _configRange.minInputElm.value = _configRange.minElm.innerHTML;
        self.onChangeEventInputRangeMin(_configRange, false);
        if (oldValue != _configRange.minInputElm.value) _configRange.inputRangeElm.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
      configRange.maxElm.addEventListener("focus", function (e) {
        var _configRange = self.configRangeList[e.target.closest(".multi-range-slider").id];
        _configRange.maxElm.innerHTML = _configRange.maxInputElm.value;
        BN.selectElementContents(_configRange.maxElm);
      });
      configRange.maxElm.addEventListener("blur", function (e) {
        var _configRange = self.configRangeList[e.target.closest(".multi-range-slider").id];
        var oldValue = _configRange.maxInputElm.value;
        if (!isNaN(_configRange.maxElm.innerHTML) && parseFloat(_configRange.maxElm.innerHTML) >= parseFloat(_configRange.minInputElm.value)) _configRange.maxInputElm.value = _configRange.maxElm.innerHTML;
        self.onChangeEventInputRangeMax(_configRange, false);
        if (_configRange.maxInputElm.value != oldValue) _configRange.inputRangeElm.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
      if (isInputMin) {
        if (init) {
          this.onChangeEventInputRangeMin(configRange, true);
        }
        configRange.minInputElm.addEventListener('input', this.onChangeEventInputRangeMin.bind(this, configRange, false), false);
      } else {
        if (init) {
          this.onChangeEventInputRangeMax(configRange, true);
        }
        configRange.maxInputElm.addEventListener('input', this.onChangeEventInputRangeMax.bind(this, configRange, false), false);
      }
    }
  }, {
    key: "addEventResetInput",
    value: function addEventResetInput(sliderId, isKeepValue) {
      var rangeSliderElm = document.querySelector("#".concat(sliderId));
      if (rangeSliderElm) this.configRangeList[sliderId] = {
        sliderId: sliderId,
        minElm: rangeSliderElm.querySelector(".multi-range-slider__sign__left span"),
        maxElm: rangeSliderElm.querySelector(".multi-range-slider__sign__right span"),
        minInputElm: rangeSliderElm.querySelector(".multi-range-slider__main__form__input--left"),
        maxInputElm: rangeSliderElm.querySelector(".multi-range-slider__main__form__input--right"),
        mainRangeElm: rangeSliderElm.querySelector(".multi-range-slider__main__form__range"),
        inverseLeftElm: rangeSliderElm.querySelector(".multi-range-slider__main__form__inverse-left"),
        inverseRightElm: rangeSliderElm.querySelector(".multi-range-slider__main__form__inverse-right"),
        thumbLeftElm: rangeSliderElm.querySelector(".multi-range-slider__main__form__thumb--left"),
        thumbRightElm: rangeSliderElm.querySelector(".multi-range-slider__main__form__thumb--right"),
        inputRangeElm: rangeSliderElm.querySelector(".multi-range-slider__input")
      };
      var elem = document.getElementById(sliderId);
      if (elem) {
        var idsInput = ['inputRangeMin', 'inputRangeMax'];
        elem.addEventListener('reset-input', function (e) {
          var _e$detail$trigger, _e$detail;
          var trigger = (_e$detail$trigger = (_e$detail = e.detail) === null || _e$detail === void 0 ? void 0 : _e$detail.trigger) !== null && _e$detail$trigger !== void 0 ? _e$detail$trigger : true;
          idsInput.forEach(function (id) {
            var input = elem.querySelector('#' + id);
            if (input) {
              var _input$dataset$defaul, _input$dataset;
              var newValue = (_input$dataset$defaul = (_input$dataset = input.dataset) === null || _input$dataset === void 0 ? void 0 : _input$dataset.defaultValue) !== null && _input$dataset$defaul !== void 0 ? _input$dataset$defaul : '';
              if (parseFloat(input.value) != newValue) {
                input.value = newValue;
                trigger && input.dispatchEvent(new Event('input', {
                  bubbles: true
                }));
                trigger && input.dispatchEvent(new Event('change', {
                  bubbles: true
                }));
              }
            }
          });
          var input = elem.querySelector('.multi-range-slider__input');
          if (input && input.value !== '' && !isKeepValue) {
            input.value = '';
            trigger && input.dispatchEvent(new Event('change', {
              bubbles: true
            }));
          }
        });

        //set range input value automatically at first load
        if (elem.querySelector('.multi-range-slider__input')) {
          var _configRange$minInput;
          var configRange = this.configRangeList[sliderId];
          if (configRange) this.setInputMoneys(configRange, (_configRange$minInput = configRange.minInputElm) === null || _configRange$minInput === void 0 ? void 0 : _configRange$minInput.value, 0);
        }
      }
    }
  }, {
    key: "reloadRangeInput",
    value: function reloadRangeInput(id) {
      var _configRange$minInput2;
      if (!id) return;
      this.addEventResetInput(id, true);
      this.addEventInputRange(id, true, true);
      this.addEventInputRange(id, false, true);
      var configRange = this.configRangeList[id];
      this.setInputMoneys(configRange, (_configRange$minInput2 = configRange.minInputElm) === null || _configRange$minInput2 === void 0 ? void 0 : _configRange$minInput2.value, 0);
    }
  }, {
    key: "addEventOTPInput",
    value: function addEventOTPInput(parentId, parentEl) {
      var inputs;
      if (parentEl) {
        inputs = parentEl.querySelectorAll("".concat(parentId, " > input"));
      } else {
        inputs = document.querySelectorAll("#".concat(parentId, " > input"));
      }
      var KEYCODE_NUMBER_0 = 48,
        KEYCODE_NUMBER_9 = 57,
        KEYCODE_PAD_NUMBER_0 = 96,
        KEYCODE_PAD_NUMBER_9 = 105;
      var numberInputEl = inputs.length;
      var ctrlActive = false;
      document.body.addEventListener('keyup', function (event) {
        if (event.key == 'Control') ctrlActive = true;
      });
      inputs[0].addEventListener('paste', function (evt) {
        evt.preventDefault();
        var pasteText = (evt.originalEvent || evt).clipboardData.getData('text/plain');
        if (pasteText && pasteText.trim().length) {
          var _pasteText$trim$match;
          pasteText = ((_pasteText$trim$match = pasteText.trim().match(new RegExp(/\d+/g))) === null || _pasteText$trim$match === void 0 ? void 0 : _pasteText$trim$match.join('')) || '';
          for (var i = 0; i < pasteText.length; i++) {
            if (inputs[i]) {
              var _inputs;
              inputs[i].value = pasteText[i];
              inputs[i].classList.remove('error');
              inputs[i].dispatchEvent(new Event('inputChange'));
              (_inputs = inputs[i + 1]) === null || _inputs === void 0 || _inputs.focus();
            }
          }
        }
      });
      var _loop = function _loop(i) {
        var currentEl = inputs[i];
        ['input', 'keydown'].forEach(function (evtName) {
          currentEl.addEventListener(evtName, function (evt) {
            if (evt.key === "Backspace") {
              currentEl.value = '';
              if (i !== 0) inputs[i - 1].focus();
            } else {
              if (i === numberInputEl - 1 && currentEl.value !== '') {
                // if it is the last input
                if (currentEl.value.length > currentEl.maxLength) {
                  currentEl.value = currentEl.value.slice(0, currentEl.maxLength);
                }
              } else if (evt.keyCode >= KEYCODE_NUMBER_0 && evt.keyCode <= KEYCODE_NUMBER_9 || evt.keyCode >= KEYCODE_PAD_NUMBER_0 && evt.keyCode <= KEYCODE_PAD_NUMBER_9) {
                currentEl.value = evt.key;
                if (i !== numberInputEl - 1) inputs[i + 1].focus();
                evt.preventDefault();
              } else {
                currentEl.value = '';
              }
              currentEl.classList.remove('error');
              currentEl.dispatchEvent(new Event('inputChange'));
            }
          });
        });
      };
      for (var i = 0; i < numberInputEl; i++) {
        _loop(i);
      }
    }
  }, {
    key: "addEventSingleInputRange",
    value: function addEventSingleInputRange(el) {
      var input = el.querySelector('input[type="range"]'),
        thumb = el.querySelector('.input-range__thumb--icon'),
        progressBar = el.querySelector('.input-range__range--progress-bar');
      function onChangeValue(value, min, max) {
        var per = Math.round((value - min) / (max - min) * 10000) / 100;
        progressBar.style.width = per + '%';
        thumb.style.left = per + '%';
      }
      if (input) {
        var _input$min, _input$max;
        var min = (_input$min = input.min) !== null && _input$min !== void 0 ? _input$min : 0,
          max = (_input$max = input.max) !== null && _input$max !== void 0 ? _input$max : 100;
        min = parseFloat(min);
        max = parseFloat(max);
        el.inputRange = true;
        input.addEventListener('input', function () {
          onChangeValue(parseInt(input.value), min, max);
        });
      }
    }
  }]);
}();
BN.domContentLoadedFncList.push(function () {
  BN.inputService = new Input();
  document.querySelectorAll(".input-range").forEach(function (inputElm) {
    if (!inputElm.inputRange) {
      BN.inputService.addEventSingleInputRange(inputElm);
    }
  });
});
"use strict";

function AppStorage() {
  var Base64 = {
    // private property
    _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    // public method for encoding
    encode: function encode(input) {
      var output = "";
      var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
      var i = 0;
      input = Base64._utf8_encode(input);
      while (i < input.length) {
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        enc1 = chr1 >> 2;
        enc2 = (chr1 & 3) << 4 | chr2 >> 4;
        enc3 = (chr2 & 15) << 2 | chr3 >> 6;
        enc4 = chr3 & 63;
        if (isNaN(chr2)) {
          enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
          enc4 = 64;
        }
        output = output + Base64._keyStr.charAt(enc1) + Base64._keyStr.charAt(enc2) + Base64._keyStr.charAt(enc3) + Base64._keyStr.charAt(enc4);
      }
      return output;
    },
    // public method for decoding
    decode: function decode(input) {
      var output = "";
      var chr1, chr2, chr3;
      var enc1, enc2, enc3, enc4;
      var i = 0;
      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
      while (i < input.length) {
        enc1 = Base64._keyStr.indexOf(input.charAt(i++));
        enc2 = Base64._keyStr.indexOf(input.charAt(i++));
        enc3 = Base64._keyStr.indexOf(input.charAt(i++));
        enc4 = Base64._keyStr.indexOf(input.charAt(i++));
        chr1 = enc1 << 2 | enc2 >> 4;
        chr2 = (enc2 & 15) << 4 | enc3 >> 2;
        chr3 = (enc3 & 3) << 6 | enc4;
        output = output + String.fromCharCode(chr1);
        if (enc3 != 64) {
          output = output + String.fromCharCode(chr2);
        }
        if (enc4 != 64) {
          output = output + String.fromCharCode(chr3);
        }
      }
      output = Base64._utf8_decode(output);
      return output;
    },
    // private method for UTF-8 encoding
    _utf8_encode: function _utf8_encode(string) {
      string = string.replace(/\r\n/g, "\n");
      var utftext = "";
      for (var n = 0; n < string.length; n++) {
        var c = string.charCodeAt(n);
        if (c < 128) {
          utftext += String.fromCharCode(c);
        } else if (c > 127 && c < 2048) {
          utftext += String.fromCharCode(c >> 6 | 192);
          utftext += String.fromCharCode(c & 63 | 128);
        } else {
          utftext += String.fromCharCode(c >> 12 | 224);
          utftext += String.fromCharCode(c >> 6 & 63 | 128);
          utftext += String.fromCharCode(c & 63 | 128);
        }
      }
      return utftext;
    },
    // private method for UTF-8 decoding
    _utf8_decode: function _utf8_decode(utftext) {
      var string = "";
      var i = 0;
      var c = 0,
        c1 = 0,
        c2 = 0,
        c3 = 0;
      while (i < utftext.length) {
        c = utftext.charCodeAt(i);
        if (c < 128) {
          string += String.fromCharCode(c);
          i++;
        } else if (c > 191 && c < 224) {
          c2 = utftext.charCodeAt(i + 1);
          string += String.fromCharCode((c & 31) << 6 | c2 & 63);
          i += 2;
        } else {
          c2 = utftext.charCodeAt(i + 1);
          c3 = utftext.charCodeAt(i + 2);
          string += String.fromCharCode((c & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
          i += 3;
        }
      }
      return string;
    }
  };
  return {
    set: function set(key, value) {
      if ("undefined" == typeof Storage) return AppToast.error("system_this_browser_does_not_support_web_storage_function_to_improve_performance"), !1;
      value = Base64.encode(JSON.stringify(value)), localStorage.setItem(key, value);
    },
    get: function get(key) {
      if ("undefined" != typeof Storage) {
        var saved = localStorage[key];
        return !!saved && JSON.parse(Base64.decode(saved));
      }
      return AppToast.error("system_this_browser_does_not_support_web_storage_function_to_improve_performance"), !1;
    },
    "delete": function _delete(key) {
      if ("undefined" == typeof Storage) return AppToast.error("system_this_browser_does_not_support_web_storage_function_to_improve_performance"), !1;
      localStorage.removeItem(key);
    },
    deleteAll: function deleteAll() {
      if ("undefined" == typeof Storage) return AppToast.error("system_this_browser_does_not_support_web_storage_function_to_improve_performance"), !1;
      localStorage.clear();
    }
  };
}
"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
BN.SetVueData("tooltip", {
  show: false,
  text: '',
  location: 'top',
  type: '',
  style: null,
  styleContent: null
});
BN.tooltip = function (el) {
  if (!el || el !== null && el !== void 0 && el.tooltipReady) return;
  var tooltip = document.getElementById('tooltip'),
    tooltipContent = tooltip && tooltip.querySelector('span');
  if (!tooltipContent) return;
  var vueModelTooltip = BNApp.$data.tooltip;
  var config = el.dataset;
  var label = config.tooltip,
    _config$tooltipLocati = config.tooltipLocation,
    location = _config$tooltipLocati === void 0 ? 'top' : _config$tooltipLocati;
  var _onMouseEnter = function onMouseEnter() {
    if (!el.tooltipReady) {
      el.removeEventListener('mouseenter', _onMouseEnter);
      return;
    }
    vueModelTooltip.show = true;
    var rect = el.getBoundingClientRect();
    var top = rect.top,
      left = rect.left,
      width = rect.width,
      height = rect.height;
    Object.assign(vueModelTooltip, {
      label: label,
      location: location,
      type: el.classList.contains('tooltip-dark') ? 'dark' : '',
      style: {
        top: top + 'px',
        left: left + 'px',
        width: width + 'px',
        height: height + 'px'
      },
      styleContent: null
    });
    BNApp.$nextTick(function () {
      var rectContent = tooltipContent.getBoundingClientRect();
      var contentLeft = rectContent.left,
        contentTop = rectContent.top,
        contentWidth = rectContent.width,
        contentHeight = rectContent.height;
      if (location === 'left' && contentLeft < 0) {
        vueModelTooltip.location = 'right';
      } else if (location === 'top' && contentTop < 0) {
        vueModelTooltip.location = 'bottom';
      } else if (location === 'right' && contentLeft + contentWidth > BN.wWidth) {
        vueModelTooltip.location = 'left';
      } else if (location === 'bottom' && contentTop + contentHeight > BN.wHeight) {
        vueModelTooltip.location = 'top';
      }
      if (location === 'top' || location === 'bottom') {
        if (contentLeft < 0) {
          vueModelTooltip.styleContent = {
            marginLeft: contentLeft * -1 + 5 + 'px'
          };
        } else if (contentLeft + contentWidth > BN.wWidth) {
          vueModelTooltip.styleContent = {
            marginLeft: BN.wWidth - contentLeft - contentWidth - 5 + 'px'
          };
        }
      } else {
        if (contentTop < 0) {
          vueModelTooltip.styleContent = {
            marginTop: contentTop * -1 + 5 + 'px'
          };
        } else if (contentTop + contentHeight > BN.wHeight) {
          vueModelTooltip.styleContent = {
            marginTop: BN.wHeight - contentTop - contentHeight - 5 + 'px'
          };
        }
      }
    });
  };
  var _onMouseLeave = function onMouseLeave() {
    if (!el.tooltipReady) {
      el.removeEventListener('mouseleave', _onMouseLeave);
      return;
    }
    vueModelTooltip.show = false;
  };
  if (label) {
    el.tooltipReady = true;
    el.addEventListener('mouseenter', _onMouseEnter);
    el.addEventListener('mouseleave', _onMouseLeave);
    el.addEventListener('focusin', _onMouseEnter);
    el.addEventListener('focusout', _onMouseLeave);
  }
};
BN.scrollEventFncList.tooltip = function () {
  var _BNApp$$data$tooltip, _BNApp;
  var vueModelTooltip = (_BNApp$$data$tooltip = (_BNApp = BNApp) === null || _BNApp === void 0 || (_BNApp = _BNApp.$data) === null || _BNApp === void 0 ? void 0 : _BNApp.tooltip) !== null && _BNApp$$data$tooltip !== void 0 ? _BNApp$$data$tooltip : {};
  if (vueModelTooltip.show) {
    vueModelTooltip.show = false;
  }
};
BN.domContentLoadedFncList.push(function () {
  document.querySelectorAll(".tooltip").forEach(function (el) {
    BN.tooltip(el);
  });
  if (window.MutationObserver) {
    var targetNode = document.body;
    var config = {
      attributes: true,
      childList: true,
      subtree: true
    };
    var callback = function callback(mutationsList, observer) {
      //script for test missing icon
      // let allSvg = [...new Set([...document.querySelectorAll('[*|href]:not([href])')].map(el => el.getAttribute('xlink:href')))],
      // allSvgAdded = [...new Set([...document.querySelectorAll('symbol')].map(el => '#' + el.getAttribute('id')))];
      // let svgMiss = allSvg.filter(svg => allSvgAdded.indexOf(svg) === -1);
      // svgMiss.length && console.log(svgMiss);
      var targets = [];
      var _iterator = _createForOfIteratorHelper(mutationsList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var mutation = _step.value;
          var target = mutation.target;
          if ((mutation.type === 'childList' || mutation.type === 'attributes') && targets.indexOf(target) === -1) {
            targets.push(target);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      targets.forEach(function (target) {
        if (target.classList.contains('tooltip')) {
          BN.tooltip(target);
        } else {
          if (target.tooltipReady) {
            target.tooltipReady = false;
          } else {
            var tooltips = target.querySelectorAll('.tooltip');
            tooltips.forEach(function (tooltip) {
              BN.tooltip(tooltip);
            });
          }
        }
      });
    };
    var observer = new window.MutationObserver(callback);
    observer.observe(targetNode, config);
  }
});
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Dialog = /*#__PURE__*/function () {
  function Dialog() {
    _classCallCheck(this, Dialog);
  }
  return _createClass(Dialog, [{
    key: "initDialogContainer",
    value: function initDialogContainer(config, callback) {
      if (!BN.vueData.components["bn-dialog-container"]) {
        BN.SetVueData("dialog", {
          list: {}
        });
        BN.SetVueComponentAtRunTime("bn-dialog-container", "dialog/container", false, function () {
          BNApp.$data.dialog.list[config.id] = config;
          BNApp.$nextTick(function () {
            callback();
          });
        }, null, true);
      } else {
        BNApp.$data.dialog.list[config.id] = config;
        BNApp.$nextTick(function () {
          callback();
        });
      }
    }
  }, {
    key: "showConfirm",
    value: function showConfirm(e, title, msg, okCallback, cancelCallback) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      options = Object.assign({
        btnConfirmText: 'Confirm',
        btnCancelText: 'Cancel'
      }, options);
      var bnConfirm = document.querySelector("bn-confirm"),
        targetElm = e.submitter || e.target,
        self = this;
      if (!bnConfirm) {
        var disableClickOutsideCl = options.disableClickOutside ? " disable-click-outside" : '';
        var dialogName = options.name ? " ".concat(options.name) : '';
        document.body.insertAdjacentHTML("beforeend", "<bn-confirm id='bn-confirm' dropdown-panel class='bn-dialog bn-dialog--confirm".concat(disableClickOutsideCl).concat(dialogName, "'></bn-confirm>"));
        bnConfirm = document.querySelector("bn-confirm");
      }
      bnConfirm.innerHTML = "\n            <div class=\"bn-dialog-container\">\n                <div dropdown-panel-container=\"\">\n                    <div class=\"bn-dialog__header\">\n                        <div class=\"bn-dialog__title\">".concat(title, "</div>\n                        <button class=\"close-btn svg-close btn-transparent\" aria-label=\"Close\">\n                            <svg height=\"20\" width=\"20\" aria-hidden=\"true\" focusable=\"false\">\n                                <title>Close</title> \n                                <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#svg_close\"></use>\n                            </svg>\n                        </button>\n                    </div>\n                    <div class=\"bn-dialog__body\">\n                        <div class=\"bn-dialog__body-content\">").concat(BN.decodeHtml(msg), "</div>\n                        <button class=\"btn btn-primary btn--large confirm\">").concat(options.btnConfirmText, "</button>\n                        ").concat(!options.hideBtnCancel ? "<button class=\"btn btn-outline-filled btn--large close-btn\">".concat(options.btnCancelText, "</button>") : '', "\n                    </div>\n                </div>\n            </div>\n        ");
      var customEvent = new CustomEvent('dialogOpen', {
        detail: {
          target: bnConfirm
        }
      });
      document.dispatchEvent(customEvent);
      bnConfirm.classList.add("show");
      BN.listDialogCursor.push(targetElm);
      BN.dropdownService && BN.dropdownService.loopFocus(bnConfirm);
      if (okCallback) bnConfirm.querySelector(".confirm").onclick = function (e) {
        okCallback();
        BN.dropdownService.close(e);
      };
      bnConfirm.querySelectorAll(".close-btn").forEach(function (item) {
        item.onclick = function (e) {
          if (cancelCallback) cancelCallback();
          BN.dropdownService.close(e);
        };
      });
    }
  }, {
    key: "showDialog",
    value: function showDialog(e, dialogConfig) {
      var targetElm = e.target,
        config = {
          id: dialogConfig.id || "bn-dialog",
          "class": dialogConfig["class"],
          title: dialogConfig.title,
          bodyTemplate: dialogConfig.bodyTemplate,
          closeCallback: dialogConfig.closeCallback,
          okCallback: dialogConfig.okCallback,
          isTinyMceFormat: dialogConfig.isTinyMceFormat,
          data: dialogConfig.data,
          externalTemplate: dialogConfig.externalTemplate,
          hideHeader: dialogConfig.hideHeader,
          isConfirmation: false
        },
        self = this;

      // externalTemplate = {
      //     name: "component-name",
      //     path: "https:// or relative path",
      //     isFromSV: true | false,          //"if path is http => true else false",
      //     callback: () => {},              // "a callback function, after child component is initialized completely"
      //     cacheTemplate: true | false      // do not reload Vue Single Component, reuse template and change data only
      // }

      //** if using externalTemplate, we should empty bodyTemplate property

      //example:
      // showRestrictions(e, product){
      //     BN.dialogService.showDialog(e, {
      //         title: "Restrictions",
      //         id: "restrictions-dialog",
      //         data: product,
      //         class: 'bn-dialog--md restrictions-dialog',
      //         externalTemplate: {
      //             name: "restrictions-dialog",
      //             path: "cart/restrictions",
      //             cacheTemplate: true,
      //             callback:  () => {
      //                 console.log(BN.vueData.components["restrictions-dialog"])
      //             }
      //         }
      //     });
      // }

      function dialogInitCallback(bnDialog) {
        bnDialog.classList.add("show");
        BN.dropdownService.loopFocus(bnDialog);
        document.body.classList.add("showing-dialog");
        BN.lockScrollIos.on(bnDialog);
        bnDialog.querySelectorAll(".close-btn").forEach(function (item) {
          item.onclick = function (e) {
            if (config.closeCallback) config.closeCallback();
            BN.dropdownService.close(e);
          };
        });
        bnDialog.querySelectorAll(".ok-btn").forEach(function (item) {
          item.onclick = function (e) {
            if (config.okCallback) config.okCallback();
            BN.dropdownService.close(e);
          };
        });
        var customEvent = new CustomEvent('dialogOpen', {
          detail: {
            target: bnDialog
          }
        });
        document.dispatchEvent(customEvent);
      }
      BNApp.$nextTick(function () {
        if (config.externalTemplate) {
          BN.SetVueComponentAtRunTime(config.externalTemplate.name, config.externalTemplate.path, config.externalTemplate.isFromSV, function () {
            self.initDialogContainer(config, function () {
              dialogInitCallback(document.querySelector("#" + config.id));
              if (config.externalTemplate.callback) config.externalTemplate.callback();
            });
          }, BN.copy(config.data), config.externalTemplate.cacheTemplate);
        } else {
          self.initDialogContainer(config, function () {
            dialogInitCallback(document.querySelector("#" + config.id));
          });
        }
        BN.listDialogCursor.push(targetElm);
      });
    }
  }, {
    key: "loadGlobalDialog",
    value: function loadGlobalDialog(callback) {
      if (!document.querySelector(".dialog-login")) BN.lazyLoadFiles({
        "css": ["components/login.css", "components/tab-footer.css", "pages/register-account.css"],
        "js": ["components/login.js", "services/auth.js"]
      }, function () {
        BN.SetVueComponentAtRunTime("global-dialog-template", "/header/GetGlobalDialogTemplates/index.vue", true, function () {
          typeof addEventDisplayPassword != "undefined" && addEventDisplayPassword();
          typeof addEventLoginForm != "undefined" && addEventLoginForm();
          typeof addEventStepVerify != "undefined" && addEventStepVerify();
          typeof addEventSubmitEmailCheckout != "undefined" && addEventSubmitEmailCheckout();
          if (callback) callback();
        });
      }, true);else if (callback) callback();
    }
  }, {
    key: "loadPromotionDialog",
    value: function loadPromotionDialog(callback) {
      if (!document.querySelector("#dialog-promotion-bar")) BN.SetVueComponentAtRunTime("global-promotion-dialog", "/header/GetGlobalPromotionBarDialog/index.vue", true, function () {
        if (callback) callback();
      });else if (callback) callback();
    }
  }, {
    key: "loadTermsAndConditionsDialog",
    value: function loadTermsAndConditionsDialog(callback) {
      if (!document.querySelector("#terms-and-conditions-dialog")) BN.SetVueComponentAtRunTime("terms-and-conditions-dialog-component", "/checkout/GetTermsAndConditionsDialog/index.vue", true, function () {
        if (callback) callback();
      });else if (callback) callback();
    }
  }]);
}();
"use strict";

BN.domContentLoadedFncList.push(function () {
  document.querySelectorAll('.alert').forEach(function (element) {
    var closeBtn = element.querySelector(".btn-close");
    if (closeBtn) {
      closeBtn.addEventListener("click", function (e) {
        e.preventDefault();
        element.remove();
      });
    }
  });
});
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CredovaService = /*#__PURE__*/function () {
  function CredovaService() {
    _classCallCheck(this, CredovaService);
  }
  return _createClass(CredovaService, [{
    key: "openCredovaPopup",
    value: function openCredovaPopup(credovaSettings) {
      this.importCredova().then(function () {
        var environment = credovaSettings.environment || "Sandbox",
          store = credovaSettings.store || "OTS000",
          minAmount = parseFloat(credovaSettings.minAmount),
          maxAmount = parseFloat(credovaSettings.maxAmount),
          price = credovaSettings.minAmount;
        CRDV.plugin.config({
          environment: CRDV.Environment[environment],
          store: store,
          minAmount: minAmount,
          maxAmount: maxAmount
        });
        CRDV.plugin.prequalify(parseFloat(price)).then(function (res) {
          if (res.approved) {
            var httpService = new HttpService();
            httpService.post('/CredovaApi/HandlePrequalifyCallbackSuccess', res, null, true).then(function (res) {
              console.log(JSON.stringify(res));
            })["catch"](function (e) {
              resolve({
                isSuccess: false,
                message: e.statusText
              });
            });
            document.cookie = "credovaApproved=y";
          } else {
            document.cookie = "credovaApproved=n";
          }
        });
      });
    }
  }, {
    key: "importCredova",
    value: function importCredova() {
      return new Promise(function (resolve) {
        if (typeof CRDV == 'undefined') {
          var urlCredovaVendor = '/dist/Brownells/js/vendors/credova.js?v=' + BN.version;
          var script = document.createElement('script');
          script.setAttribute('src', urlCredovaVendor);
          script.onload = function () {
            resolve();
          };
          document.body.appendChild(script);
        } else {
          resolve();
        }
      });
    }
  }, {
    key: "openCredovaApplicationSubmitPopup",
    value: function openCredovaApplicationSubmitPopup(credovaSettings, publicId, callback) {
      this.importCredova().then(function () {
        var environment = credovaSettings.environment || "Sandbox",
          store = credovaSettings.store || "OTS000",
          minAmount = parseFloat(credovaSettings.minAmount),
          maxAmount = parseFloat(credovaSettings.maxAmount),
          price = credovaSettings.minAmount;
        CRDV.plugin.config({
          environment: CRDV.Environment[environment],
          store: store,
          minAmount: minAmount,
          maxAmount: maxAmount
        });
        CRDV.plugin.checkout(publicId).then(function (completed) {
          if (callback) {
            callback(completed);
          }
        });
      });
    }
  }]);
}();
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Toast = /*#__PURE__*/function () {
  function Toast() {
    _classCallCheck(this, Toast);
    this.options = {
      prependTo: document.body.childNodes[1],
      lifeSpan: 3000,
      animate: true,
      animateDuration: 1000,
      delay: 0
    };
    this.classes = {
      container: 'toast__container',
      animate: 'toast--exit',
      "default": 'toast',
      success: 'toast--success',
      info: 'toast--info',
      warning: 'toast--warning',
      error: 'toast--error'
    };
  }
  return _createClass(Toast, [{
    key: "setOptions",
    value: function setOptions(opts) {
      for (var key in opts) {
        if (opts.hasOwnProperty(key)) {
          if (key in this.options) {
            this.options[key] = opts[key];
          }
        }
      }
    }
  }, {
    key: "setClasses",
    value: function setClasses(classDict) {
      for (var key in classDict) {
        if (classDict.hasOwnProperty(key)) {
          if (key in this.classes) {
            this.classes[key] = classDict[key];
          }
        }
      }
    }
  }, {
    key: "customForIe",
    value: function customForIe(node) {
      Object.defineProperty(node, 'remove', {
        configurable: true,
        enumerable: true,
        writable: true,
        value: function remove() {
          if (this.parentNode !== null) this.parentNode.removeChild(this);
        }
      });
    }
  }, {
    key: "placeToast",
    value: function placeToast(msg, toastType) {
      var _this = this;
      var options = this.options;
      var classes = this.classes;
      var self = this;
      var init = function init() {
        var htmlContent = "<div class=\"toast__container\">\n                    <div class=\"toast__logo\">\n                        <svg class=\"toast__icon toast__icon--sm toast__icon--logo\" aria-hidden=\"true\" focusable=\"false\">\n                            <title>Success</title>\n                            <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#svg_shield\" />\n                        </svg>\n                        <svg class=\"toast__icon toast__icon--md toast__icon--logo-error\" aria-hidden=\"true\" focusable=\"false\">\n                            <title>Error</title>\n                            <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#svg_close_32\" />\n                        </svg>\n                        <svg class=\"toast__icon toast__icon--sm toast__icon--logo-warning\" aria-hidden=\"true\" focusable=\"false\">\n                            <title>Warning</title>\n                            <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#svg_warning_24\" />\n                        </svg>\n                    </div>\n                    <div class=\"toast__text\">\n                        ".concat(msg, "\n                    </div>\n                    <div class=\"toast__close\">\n                        <svg class=\"toast__icon toast__icon--close\" aria-hidden=\"true\" focusable=\"false\">\n                            <title>Close</title>\n                            <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#svg_close_24\" />\n                        </svg>\n                    </div>\n                </div>");
        var toastParent = document.querySelector('.' + _this.classes["default"]);
        var parentExists = !!toastParent;
        if (!toastParent) {
          toastParent = document.createElement('div');
        }
        toastParent.className = "".concat(_this.classes["default"], " ").concat(_this.classes[toastType]);
        _this.customForIe(toastParent);
        toastParent.innerHTML = htmlContent;
        if (!parentExists) {
          document.body.appendChild(toastParent);
        }
        document.querySelector('.toast__close').addEventListener('click', function () {
          self.close();
        });
        // This timeout is used for the duration that the toast will stay on the page
        setTimeout(function () {
          // Animation is set to perform
          if (options.animate && options.animateDuration) {
            toastParent.classList.add(classes.animate);

            // This timeout is used to defer the removal of the toast from the DOM
            setTimeout(function () {
              var _document$querySelect;
              if ((_document$querySelect = document.querySelector('.' + classes["default"])) !== null && _document$querySelect !== void 0 && _document$querySelect.childNodes.length) {
                toastParent.remove();
              }
            }, options.animateDuration);
          } else {
            var _document$querySelect2;
            if ((_document$querySelect2 = document.querySelector('.' + classes["default"])) !== null && _document$querySelect2 !== void 0 && _document$querySelect2.childNodes.length) {
              toastParent.remove();
            }
          }
        }, options.lifeSpan);
      };
      setTimeout(init, options === null || options === void 0 ? void 0 : options.delay);
    }
  }, {
    key: "close",
    value: function close() {
      var _document$querySelect3;
      (_document$querySelect3 = document.querySelector(".toast")) === null || _document$querySelect3 === void 0 || _document$querySelect3.remove();
    }
  }, {
    key: "displayToast",
    value: function displayToast() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var type = arguments.length > 1 ? arguments[1] : undefined;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.setOptions(options);
      if (!message && type == "error") message = "Server error! Not your fault.";
      this.placeToast(message, type);
    }
  }]);
}();
BN.domContentLoadedFncList.push(function () {
  BN.toastService = new Toast();
});
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SpeedToolsService = /*#__PURE__*/function () {
  function SpeedToolsService() {
    _classCallCheck(this, SpeedToolsService);
  }
  return _createClass(SpeedToolsService, [{
    key: "IsPerformanceToolVisiting",
    value: function IsPerformanceToolVisiting() {
      var check = false;
      (function (a) {
        if (/lighthouse|speedcurve|page speed|headless|webpagetest|screaming frog|addthis|PTST|googlebot|adsbot|feedfetcher|mediapartners|spider|bingbot|apica/gi.test(a)) check = true;
      })(navigator.userAgent);
      return check;
    }
  }]);
}();
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//===========GTM Product Impression tracking
BN.productImpressionTracking = function ($productElements, productDatalayer) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    list = _ref.list;
  if (!$productElements && !productDatalayer && $productElements.length != productDatalayer.length) return;
  var observeImpression = new window.IntersectionObserver(function (entries) {
    if (entries.length) {
      var impressions = [];
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var position = $productElements.findIndex(function (item) {
            return item === entry.target;
          });
          impressions.push(_objectSpread(_objectSpread({}, productDatalayer[position]), {}, {
            list: list,
            position: position + 1
          }));
          observeImpression.unobserve(entry.target);
        }
      });
      if (impressions.length) {
        var _BN;
        BN.pushDataLayer(null, null, {
          'event': 'view_item_list',
          'ecommerce': {
            'currencyCode': (_BN = BN) === null || _BN === void 0 || (_BN = _BN.defaultConfig) === null || _BN === void 0 ? void 0 : _BN.currencyCode,
            'impressions': impressions
          }
        });
      }
    }
  }, {
    root: null,
    rootMargin: "0px",
    threshold: 0.5 // set offset 0.1 means trigger if atleast 10% of element in viewport
  });
  $productElements.forEach(function (productElement) {
    if (productElement) {
      observeImpression.observe(productElement);
    }
  });
};

//===========GTM Block tracking
BN.blockTracking = function () {
  var blocks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var blockItems = {
    "herocarouselblock-item": {
      selector: ".herocarouselblock .hero-banner-block",
      navigateSelector: "a[href]"
    },
    "splitmediaandcontentblock": {
      selector: ".splitmediaandcontentblock",
      navigateSelector: "a[href]"
    },
    "brandcontent-item": {
      selector: ".brandcarouselblock .brand__content--item",
      navigateSelector: "a[href]"
    },
    "productcategorycarouselblock-item": {
      selector: ".productcategorycarouselblock .category-slider__item",
      navigateSelector: "a[href]",
      blockIsNavigateSelector: true
    },
    "recommedendproductsblock": {
      selector: ".recommedendproductsblock",
      navigateSelector: "a[href], .category-slider__item__cart-btn"
    },
    "global-promotion-bar-block": {
      selector: ".promotion-bar",
      blockIsNavigateSelector: true
    },
    "mega-menu-banner-block": {
      selector: ".mega-banner",
      blockIsNavigateSelector: true
    },
    "mega-menu-promo-banner-block": {
      selector: ".mega-menu-promo",
      blockIsNavigateSelector: true
    },
    "deals-featured-products-carousel": {
      selector: ".deals-featured-products-carousel-block",
      navigateSelector: "a[href], .category-slider__item__cart-btn"
    },
    "homepage-left-content-block": {
      selector: ".homepage-left-content-block",
      navigateSelector: "a[href]",
      blockIsNavigateSelector: true
    },
    "homepage-right-content-block": {
      selector: ".homepage-right-content-block",
      navigateSelector: "a[href]",
      blockIsNavigateSelector: true
    },
    "homepage-banner-block": {
      selector: ".homepage-banner-block",
      navigateSelector: "a[href]",
      blockIsNavigateSelector: true
    },
    "media-and-content-selection-block": {
      selector: ".media-and-content-selection-block",
      navigateSelector: "a[href]",
      blockIsNavigateSelector: true
    }
  };
  var observeImpression = new window.IntersectionObserver(function (entries) {
    if (entries.length) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var _contentarea$dataset, _entry$target$dataset, _contentBlock$dataset, _contentBlock$dataset2, _contentBlock$dataset3;
          var contentarea = entry.target.closest("[data-contentarea-name]");
          var contentareaName = contentarea === null || contentarea === void 0 || (_contentarea$dataset = contentarea.dataset) === null || _contentarea$dataset === void 0 ? void 0 : _contentarea$dataset.contentareaName;
          var contentBlock = (_entry$target$dataset = entry.target.dataset) !== null && _entry$target$dataset !== void 0 && _entry$target$dataset.blockId ? entry.target : entry.target.querySelector("[data-block-id]");
          var contentBlockName = contentBlock === null || contentBlock === void 0 || (_contentBlock$dataset = contentBlock.dataset) === null || _contentBlock$dataset === void 0 ? void 0 : _contentBlock$dataset.blockName;
          var contentBlockId = contentBlock === null || contentBlock === void 0 || (_contentBlock$dataset2 = contentBlock.dataset) === null || _contentBlock$dataset2 === void 0 ? void 0 : _contentBlock$dataset2.blockId;
          var positionBlock = contentBlock === null || contentBlock === void 0 || (_contentBlock$dataset3 = contentBlock.dataset) === null || _contentBlock$dataset3 === void 0 ? void 0 : _contentBlock$dataset3.blockIndex;
          var isClickable = contentBlock === null || contentBlock === void 0 ? void 0 : contentBlock.hasAttribute("is-clickable");
          observeImpression.unobserve(entry.target);
          BN.pushDataLayer(null, null, {
            'event': 'content_block_impression',
            'contentBlockName': contentBlockName,
            'contentBlockID': contentBlockId,
            'contentBlockCreative': null,
            'contentBlockLocation': contentareaName,
            'isClickable': isClickable ? "yes" : "no",
            'position': positionBlock
          });
        }
      });
    }
  }, {
    root: null,
    rootMargin: "0px",
    threshold: 0.5 // set offset 0.1 means trigger if atleast 10% of element in viewport
  });
  var _loop = function _loop() {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      block = _Object$entries$_i[1];
    if (blocks.includes(key)) {
      document.querySelectorAll(block.selector).forEach(function (blockNode) {
        if (!blockNode.classList.contains("loaded")) {
          var _blockNode$dataset, _contentarea$dataset2, _contentBlock$dataset4, _contentBlock$dataset5;
          var contentBlockTracking = function contentBlockTracking(target) {
            BN.pushDataLayer(target, "click", {
              'event': 'content_block_click',
              'contentBlockName': contentBlockName,
              'contentBlockID': contentBlockId,
              'contentBlockCreative': null,
              'contentBlockLocation': contentareaName,
              'position': positionBlock,
              'isClickable': isClickable ? "yes" : "no"
            });
          };
          observeImpression.observe(blockNode);
          var contentarea = blockNode.closest("[data-contentarea-name]");
          var contentBlock = (_blockNode$dataset = blockNode.dataset) !== null && _blockNode$dataset !== void 0 && _blockNode$dataset.blockId ? blockNode : blockNode.querySelector("[data-block-id]");
          var contentareaName = contentarea === null || contentarea === void 0 || (_contentarea$dataset2 = contentarea.dataset) === null || _contentarea$dataset2 === void 0 ? void 0 : _contentarea$dataset2.contentareaName;
          var contentBlockName = contentBlock === null || contentBlock === void 0 || (_contentBlock$dataset4 = contentBlock.dataset) === null || _contentBlock$dataset4 === void 0 ? void 0 : _contentBlock$dataset4.blockName;
          var contentBlockId = contentBlock === null || contentBlock === void 0 || (_contentBlock$dataset5 = contentBlock.dataset) === null || _contentBlock$dataset5 === void 0 ? void 0 : _contentBlock$dataset5.blockId;
          var positionBlock = Array.from((contentarea === null || contentarea === void 0 ? void 0 : contentarea.querySelectorAll(block.selector)) || []).indexOf(blockNode) + 1;
          var isClickable = contentBlock === null || contentBlock === void 0 ? void 0 : contentBlock.hasAttribute("is-clickable");
          if (contentBlock) {
            contentBlock.dataset.blockIndex = positionBlock;
          }
          if (block !== null && block !== void 0 && block.navigateSelector) {
            blockNode.querySelectorAll(block.navigateSelector).forEach(function (nav) {
              contentBlockTracking(nav);
            });
          }
          if (block !== null && block !== void 0 && block.blockIsNavigateSelector) {
            contentBlockTracking(blockNode);
          }
          blockNode.classList.add("loaded");
        }
      });
    }
  };
  for (var _i = 0, _Object$entries = Object.entries(blockItems); _i < _Object$entries.length; _i++) {
    _loop();
  }
};
BN.domContentLoadedFncList.push(function () {
  BN.blockTracking(["herocarouselblock-item", "splitmediaandcontentblock", "brandcontent-item", "productcategorycarouselblock-item"]);
});